var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapaDatosPt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1511 1780",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #8bd0b3;\n      }\n\n      .st3 {\n        opacity: .5;\n      }\n\n      .st3, .st4, .st5 {\n        mix-blend-mode: multiply;\n      }\n\n      .st6 {\n        fill: #75a5ea;\n      }\n\n      .st4, .st7 {\n        isolation: isolate;\n      }\n\n      .st4, .st8 {\n        fill: #ffed5e;\n      }\n\n      .st9 {\n        fill: #98dcf9;\n      }\n\n      .st10 {\n        fill: #002665;\n      }\n\n      .st11 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st13 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st14 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st15 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st16 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st17 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st18 {\n        fill: #32c984;\n      }\n\n      .st19 {\n        fill: #fff;\n      }\n\n      .st20 {\n        fill: #26569b;\n      }\n\n      .st21 {\n        fill: #00a6fc;\n      }\n\n      .st22 {\n        mix-blend-mode: darken;\n      }\n\n      .st23 {\n        fill: #1bcc7b;\n      }\n\n      .st24 {\n        fill: #e8ff0f;\n      }\n\n      .st25 {\n        fill: #0056e0;\n      }\n\n      .st26 {\n        fill: #f7fc9d;\n      }\n\n      .st27 {\n        clip-path: url(#clippath);\n      }\n\n      .st28 {\n        fill: #bececd;\n      }\n\n      .st1 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "545 450.9 541.2 447.1 541.2 440.5 555.3 426.4 579.7 426.4 579.7 419.1 575.9 419.1 553.6 396.8 567 396.8 567 385.5 567 381.4 605.6 381.4 605.6 378 613.6 378 613.6 370.3 628.5 355.4 628.5 362.8 632.8 367.1 636.9 363 636.9 346 634.1 346 634.1 336.7 638.2 332.7 638.2 321.9 649.7 310.4 649.7 301.4 641.1 292.7 637.3 296.5 612.5 296.5 609.5 299.5 575.1 313.3 575.1 335.8 568.8 342 568.8 351.8 558.2 362.4 558.2 369.1 555.2 372.1 544.9 372.1 544.9 367.9 530.1 367.9 530.1 374.8 519.2 374.8 510 374.8 504.9 379.9 488.7 379.9 480 371.2 461.3 371.2 441.1 351 424.8 334.7 424.8 322.2 409.9 307.3 409.9 258 416.7 251.2 416.7 227.2 431.3 212.6 431.3 206.3 409 206.3 386.5 206.3 386.5 191.4 375 179.9 365.7 170.7 365.7 154.8 352.1 141.2 339.1 128.2 321.3 128.2 312.9 136.6 307.7 141.8 300 141.8 282.1 123.9 282.1 112.6 247.9 78.5 215.1 78.5 215.1 85.4 160.8 85.4 149.9 74.6 136 74.6 85.4 40.2 52.1 39.7 52.1 104 94.6 146.5 75 146.5 102.4 173.8 109.4 173.8 128.5 192.9 128.5 212.5 123.4 217.6 123.4 225.7 166.9 269.2 176.2 259.8 151.2 234.8 156.9 229 140.1 212.1 140.1 186.3 134.8 186.3 134.8 172.5 117.8 155.4 117.8 141.9 89.4 113.5 89.4 80.8 85.2 76.6 85.2 55.1 101.9 71.8 106.3 67.4 121 82.1 121 94.2 125.3 94.2 125.3 109.1 168.4 152.3 158.1 162.5 190.4 194.7 180.5 204.6 187.4 211.4 191.7 207.1 209.8 225.2 209.8 234.6 255 279.8 255 304.7 261 310.7 261 328.9 248.7 328.9 248.7 340.5 275 366.8 284.1 366.8 297.5 380.2 307.6 390.3 333.8 390.3 355.7 412.1 377 412.1 408.9 444 452.9 444 477.9 419 504.7 419 544.9 459.1 545 459.1 545 450.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1439 776.1 1425.7 776.1 1389.1 739.5 1344.8 739.5 1325.6 720.3 1306.3 739.6 1298.8 747.1 1301 728.6 1298.2 728.6 1303 723.9 1295.7 716.5 1289.8 716.5 1287.9 718.5 1285.7 718.5 1281.2 714 1276.1 709 1269.5 709 1265.5 709 1259.3 702.8 1253.6 702.8 1251.2 705.2 1249.3 703.3 1246 703.3 1242.8 706.5 1242.8 711 1235.6 718.2 1229.6 718.2 1229.6 721 1223.5 727.2 1223.5 732.2 1218.9 736.7 1221.2 739 1221.2 747.6 1219.3 747.6 1213.4 741.7 1213.4 737.5 1218.3 732.6 1218.3 727.6 1221.4 724.5 1219.3 722.3 1214.9 726.7 1212.6 724.4 1204.7 724.4 1202.1 721.8 1204.7 721.8 1207.3 719.3 1214.1 719.3 1217.4 719.3 1221.3 715.3 1223.5 717.5 1227.3 713.7 1232.2 713.7 1232.2 710.5 1238.2 704.4 1238.2 696.4 1234 696.4 1231.2 693.5 1226.9 693.5 1222.8 697.6 1218 697.6 1214.1 693.7 1207.9 693.7 1202.2 699.4 1204.8 702 1200.7 706.1 1198.4 706.1 1189.7 714.9 1184.8 714.9 1191.8 707.9 1191.8 704.9 1181.7 714.9 1177.5 714.9 1183.5 708.9 1179.8 705.2 1189 696 1199.7 685.3 1213.4 671.6 1210.5 668.7 1213.5 665.7 1200.5 652.6 1200.5 643.6 1191.5 634.7 1191.5 624 1190 624 1190.9 624.9 1179 636.7 1179 645.2 1159.4 664.9 1152.7 658.2 1147.4 663.5 1141 657 1141 651.8 1136.5 647.3 1119.1 647.3 1116.3 650.2 1121.8 655.6 1121.8 663.2 1096 663.2 1092.3 666.9 1086.7 666.9 1079.5 674 1070 674 1051.3 655.4 1051.3 637 1055.9 632.4 1055.9 627.7 1059.7 623.9 1055.4 619.7 1045.3 619.7 1052.7 612.3 1052.7 608 1049.9 605.3 1043.4 605.3 1043.4 613.1 1033.1 623.4 1019.5 623.4 1015.4 619.3 1006.2 628.5 988 628.5 983 623.4 977 623.4 987.9 634.3 981.5 640.7 981.5 651.8 996.9 651.8 1004.6 659.6 987.1 659.6 963.4 683.4 950.4 683.4 940.3 673.3 933.9 673.3 933.9 666.1 928.7 660.9 927.2 660.9 922 666.1 918.8 663 917.6 663 915.2 665.3 898.4 665.3 898.4 668.3 901.6 671.5 904.6 671.5 909.9 676.8 906.1 680.6 907.8 682.2 907.8 689.3 902.2 683.8 894 692 894 695.6 906.6 708.2 906.6 718.2 893.7 760.6 893.7 765.9 892.1 765.9 890.7 770.5 890.7 765.9 886.4 765.9 881.8 761.3 879.2 761.3 879.2 764.2 866.6 764.2 860.1 770.8 854.2 770.8 846 778.9 846 787.2 841 792.3 841 799.6 834.8 805.7 834.8 822.5 848.5 836.2 841.7 843 853.5 843 859.2 848.7 859.2 853.5 872 853.5 883.5 842 890.1 848.5 884.6 853.9 884.6 871.9 901.4 871.9 902 872.5 916.9 872.5 922.6 866.8 927.9 866.8 944.9 849.8 969.5 849.8 969.5 876.2 987.4 894 987.4 891.9 996.9 891.9 1001.5 896.5 1010.3 896.5 1010.3 903.9 1028.8 903.9 1028.8 908.7 1036 915.9 1043 908.9 1053.3 919.2 1053.3 935.9 1048.5 940.7 1056.1 948.4 1056.1 955.2 1085.1 955.2 1085.1 974.6 1091.4 974.6 1104.2 987.5 1104.2 1000.2 1094.9 1009.5 1094.9 1015.8 1092 1018.7 1100 1026.7 1100 1059.8 1119.9 1059.8 1129.1 1050.6 1141.2 1062.7 1141.2 1085.5 1144.1 1088.4 1151.3 1081.2 1156.9 1086.8 1156.9 1110.7 1167.5 1110.7 1167.5 1118 1171.4 1121.9 1171.4 1144.6 1162.2 1144.6 1111.5 1195.3 1111.5 1196.7 1127.7 1196.7 1142.6 1211.6 1146.4 1207.8 1155 1216.4 1161.3 1216.4 1167.2 1222.3 1167.2 1227.8 1174.1 1227.8 1188.1 1241.8 1188.1 1249 1183.7 1253.4 1189.8 1259.5 1192.2 1257.1 1194.2 1252.4 1200.1 1232.4 1195.8 1228 1197.2 1226.8 1197.2 1223.4 1199.3 1221.3 1203.3 1217.3 1203.3 1214.6 1204.9 1214.6 1206.7 1216.3 1209.5 1213.5 1209.5 1209.1 1211.4 1207.2 1211.4 1204.6 1213.2 1202.9 1215.2 1200.8 1215.2 1198.7 1213.1 1196.6 1213.1 1193.1 1210.7 1190.7 1211.5 1189.9 1215.2 1189.9 1215.2 1193.8 1219.6 1198.2 1223.5 1198.2 1223.5 1202.6 1221.6 1202.6 1221.6 1208.1 1217.5 1214.5 1214.2 1214.5 1214.2 1218.5 1211.7 1221 1209.6 1221 1206 1224.7 1206 1226 1202.4 1226 1202.4 1227.9 1204.2 1229.7 1214.5 1222.3 1220.6 1214.8 1229.3 1200.2 1229.3 1197 1232.4 1188.7 1239.7 1174.8 1247.8 1164.1 1252.2 1155.3 1252.2 1150 1252.2 1147.2 1245 1125.2 1250.8 1125.2 1250.8 1116.2 1247.9 1113.3 1298.8 1062.3 1347.9 1062.3 1364 1046.2 1383.1 1008 1383.1 987.1 1391 979.2 1391 897.2 1401 897.2 1412.1 897.2 1412.1 878.3 1428.3 862 1461.7 828.6 1461.7 798.9 1439 776.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1061.1 552.6 1049.7 564 1046.1 564 1043.1 566.9 1043.1 572.5 1050.5 572.5 1050.5 582.8 1038.7 582.8 1030.9 590.6 1042.5 602.3 1051.2 602.3 1055.7 606.8 1055.7 613.6 1052.5 616.7 1056.7 616.7 1063.9 623.9 1058.9 629 1058.9 633.7 1054.3 638.2 1054.3 654.1 1071.2 671 1078.3 671 1085.4 663.9 1091.1 663.9 1094.7 660.2 1110.1 660.2 1096.9 647.1 1096.9 635.4 1092.4 635.4 1092.4 630.7 1086.2 624.5 1080.4 624.5 1080.4 618.9 1088 611.3 1088 606.8 1094.5 606.8 1099 602.4 1099 596.3 1098.5 596.5 1098.5 586.1 1092 586.1 1084.1 578.3 1080.4 581.9 1076.3 586.1 1073.7 586.1 1073.7 576.6 1073.7 570.1 1065.7 562 1065.7 557.2 1061.1 552.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M917.6,961v-2.2l-7.7-7.7v-53.4l6.6-6.6-16.3-16.3h-18.5v-22.2l4.2-4.2-2.3-2.3-10.3,10.3h-17.1v-6.6l-4-4h-17.8l9.8-9.8-12.4-12.4v-19.2l6.2-6.2v-7.3l5.1-5.1v-8.3l9.9-9.9h5.9l6.5-6.5h10.8v-2.9h6.9l4.6,4.6h3v-5.6l-2.3-2.3h-9.6v-4.2l8.7-14.3-8.1-8.1-7.1,7.1-7.2-7.2-7,7h-17.2v-7.7l-5.2-5.2v-4.5l-2.7-2.7h-9.7v-12.2l-6.3-6.3h-8.4l3.6,3.6v12.1h-6.1v2.3l-23.3,23.3h-4.1v1.7l-1,.4c-7,2.7-10,3.6-11.4,3.7-.4.4-1,1.2-1.6,1.9l-15.4,29h-4.5l-5.6-5.6h-7.1v-5.3h-9.2v-6.3l4.2-4.2h.3l-.7-.7h-7l-11.4,11.4v13.7l9.1,9.1h-7.6v8.1l7.4,7.4h12.5l10.2,10.2v8.7l55,98.9,44,44h21.8l33.3,33.3,7.6-7.9,1.7,1.7,2.2-2.2-3-3,4.6-4.6-1.8-1.8v-6.4l12-12h.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M945.7,853.2l-16.2,16.2c-.2.2-.6.4-.9.4h-4.3c-.3,0-.7,0-.9.4l-4.9,4.9c-.2.2-.6.4-.9.4h-9.5c-1.1,0-1.7,1.4-.9,2.2l12.6,12.6c.5.5.5,1.3,0,1.8l-6.5,6.5c-.2.2-.4.6-.4.9v49.9c0,.3,0,.7.4.9l6.9,6.9c.2.2.4.6.4.9v3.6c0,.3,0,.7-.4.9l-11.2,11.2c-.2.2-.4.6-.4.9v.2c0,.7.6,1.3,1.3,1.3h1.3c.7,0,1.3.6,1.3,1.3v6.9c0,.3,0,.7.4.9l3.8,3.8c.2.2.4.6.4.9v11.7c0,.3,0,.7.4.9l10.4,10.4c.2.2.4.6.4.9v2.6c0,.3,0,.7-.4.9l-.3.3c-.5.5-.5,1.3,0,1.8l1.6,1.6c.5.5.5,1.3,0,1.8l-4.7,4.7c-.5.5-.5,1.3,0,1.8l10.6,10.6v.3c0,0,11,29.8,11,29.8.2.5.7.8,1.2.8h.9c.3,0,.7,0,.9-.4l.8-.8c.2-.2.6-.4.9-.4h1.8c.3,0,.7,0,.9-.4l3.8-3.8c.2-.2.4-.6.4-.9v-3.4c0-.3,0-.7.4-.9l6.7-6.7c.2-.2.6-.4.9-.4h3.1c.3,0,.7,0,.9.4l3,3c.2.2.6.4.9.4h18c.7,0,1.3.6,1.3,1.3v3.5c0,.3,0,.7.4.9h0c.8.9,2.2.4,2.2-.8s0-.7.4-.9l6-6c.2-.2.6-.4.9-.4h15.3c.6,0,1.1-.4,1.3-1l1.7-9.4v-14c0-.3,0-.7.4-.9l9.9-9.9c.2-.2.4-.6.4-.9v-8.8c0-.7.6-1.3,1.3-1.3h21.2c.3,0,.7,0,.9-.4l2.1-2.1c.2-.2.6-.4.9-.4h20.1c.3,0,.7,0,.9.4l10,10c.5.5,1.3.5,1.8,0l.7-.7c.2-.2.4-.6.4-.9v-5.3c0-.3,0-.7.4-.9l8.6-8.6c.2-.2.4-.6.4-.9v-9.1c0-.3,0-.7-.4-.9l-10.3-10.3c-.2-.2-.6-.4-.9-.4h-6.2c-.7,0-1.3-.6-1.3-1.3v-16.9c0-.7-.6-1.3-1.3-1.3h-26.4c-.7,0-1.3-.6-1.3-1.3v-6.8c0-.3,0-.7-.4-.9l-7.6-7.6c-.5-.5-.5-1.3,0-1.8l4.8-4.8c.2-.2.4-.6.4-.9v-13.2c0-.3,0-.7-.4-.9l-6-6c-.5-.5-1.3-.5-1.8,0l-5.2,5.2c-.5.5-1.3.5-1.8,0l-8.9-8.9c-.2-.2-.4-.6-.4-.9v-1.2c0-.7-.6-1.3-1.3-1.3h-15.9c-.7,0-1.3-.6-1.3-1.3v-4.9c0-.7-.6-1.3-1.3-1.3h-5.3c-.3,0-.7,0-.9-.4l-3.8-3.8c-.2-.2-.6-.4-.9-.4h-3.5c-.7,0-1.3.6-1.3,1.3v2c0,1.1-1.4,1.7-2.2.9l-21.3-21.3c-.2-.2-.4-.6-.4-.9v-22.8c0-.7-.6-1.3-1.3-1.3h-18.6c-.3,0-.7,0-.9.4l-.3.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1077.3 1008.3 1058.7 1008.3 1055.8 1011.1 1034.5 1011.1 1034.5 1020 1023.9 1030.7 1023.8 1044.4 1021.8 1055.5 1027.6 1061.3 1032.4 1061.3 1032.4 1069.8 1042.3 1079.8 1048.6 1079.8 1054.1 1085.2 1054.1 1088.4 1064.7 1088.4 1073.1 1096.7 1078 1096.7 1085.6 1104.3 1096.2 1104.3 1107.9 1116 1107.9 1122.1 1099.5 1130.4 1099.5 1138.9 1093.4 1145 1093.4 1146.4 1116.7 1146.4 1122.4 1152.1 1129.2 1152.1 1153.9 1127.4 1153.9 1088 1151.3 1085.4 1144.1 1092.6 1138.2 1086.7 1138.2 1064 1129.1 1054.8 1121.1 1062.8 1097 1062.8 1097 1027.9 1077.3 1008.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1126,1309.6v-5.4l5.1-5.1v-6.1l-7.9-7.9h-8.8v-9.3l-1,1.1-11.5-10.7v-9.2l6.6-6.6v-56.1l52.5-52.5h7.4v-18.5l-3.9-3.9v-5.5h-7.6v14.9l-26.4,26.4h-9.3l-5.7-5.7h-25.1v-5.6l6.2-6.2v-8.5l8.4-8.4v-3.6l-10-10h-10.6l-7.6-7.6h-5l-8.4-8.4h-12.4v-4.9l-3.7-3.7h-6.3l-11.7-11.7v-6.8h-3.1l-6.8-6.8h-16.3l-5,5v9.6l-8.7-8.7v-3.6h-18l-3.8-3.8h-1.6l-5.7,5.7v4.5l-5.5,5.5v6.1l-3.8,16.7-18.3,9.7-.8,2.6,3.1,2.6v4.2l-2.9,2.9c-.4.8-.8,2.4-.2,3l6.3,6.3v5.6l-2.3,2.3v1.9l2.7,2.7v5.1l1.9,1.9-13.6,13.6v6.1l-4.6,4.6v12.5l-2.7,2.7v5.9l5.2,5.2v10.3l-4.2,4.2v8.4h-4.9v13.4l3.5,3.5v5.1l8.5,8.5v10.2l2.6,2.6v21.3h-4.3l-4.2,4.2,2.7,2.7v6.4l-3.6,3.6,8.1,8.1v7.1l-9,9v26.8l6.5,6.5v4.5l3.4,3.4-6.1,6.1v7.9l-7.8,7.8v4.5l4.6,4.6v30.3l3.4,3.4v6.3l-2.9,2.9v10l7.1,7.1v8.7l5.5,5.5v8.9h.6l2.3-2.3,3.5,3.5v5.4l-4.2,4.2h-7.8l-.3.3,1.2,1.2,1.3-1.3h5.3l9.4,9.4v6.8l-4.4,4.4v13.8l6.1,6.1-5.6,5.6v2.4l5.8,5.8-6.1,6.1v16.1l3.3,3.3v10.6l-11,11v13.8l-2.5,2.5v6.7l7.7,7.7h1.7l6.4-6.4h7.1v15.3l4,4v3l1.8,1.8v5.7h9.1l2.1,2.1,2.7-2.7h30.1l2.2,2.2h3.4l4.3,5.2-.7.6,2.4,2.4v-3.2l-6.9-6.9v-2.4l-2.9-2.9h-3l-1.5-1.5,1.6-1.6v-5.1l-8.4-8.4v-10.1l7.1-7.1v-7.9l5.7,5.7,10.3-10.3v-7.2h-7.3l5.9-5.9v-5.1l3.4-3.4h2.9v-4l3.5-3.5h2v-2.9l4.4-4.4v-3l1.5-1.5-1.7-1.7h-2.1l3-3v-11.1h-13.5l-10-10h-3.2l-3.4-3.4-4.3-4.3v-4.2l-1.9-1.9v-3.1l17.3-17.3h14.2v-2.7h-4.9v-5.1l4-4,2.7-2.7-4.6-4.6v-17.5l2.8-2.8h4.5l4.3-4.3v-1.8h-7.4l-2.7-2.7,2.6-2.6,4.1-4.1h3.3l3.1,3.1v4.8l2.4,2.4,5.2-5.2,2.5-2.5-4.8-4.8,1.7-1.7v-3.9l-2.2-2.2-4.6,4.6v2.5h-5.5v-2.4h-5.6l-3.8-3.8v-13.2l-5.2-5.2v-6.4l3.7-3.7h3.4v3.1h8.3l6.2,6.2h13.8l6.6-6.6v-4l3.2-3.2-2.4-2.4-3-3v-7.1l4.3-4.3v-3.9h-2.8v-10.2l-2.5-2.5v-2.1l1.8-1.8,2,2h4.2l5.4,5.4h3.5l3.1-3.1h5.8l2,2h5.9l39-18.4v-10.1l8.8-8.8v-10.9h-6.8l-7.4-7.4h.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1008.1,1651h-3.3l-2.2-2.2h-27.6l-3.9,3.9-3.3-3.3h-10.8v-7.5l-1.8-1.8v-3l-4-4v-13.5h-2.8l-6.4,6.4h-4.2l-9.4-9.4v-9.2l2.5-2.5v-13.8l11-11v-8.2l-3.3-3.3v-18.5l4.8-4.9-4.6-4.6v-4.8l4.3-4.3-4.9-4.9v-16.3l4.4-4.4v-4.3l-7.7-7.7h-2.8l-2.6,2.6-5.5-5.5,3.3-3.3h7.8l2.4-2.4v-2.9l-.5-.5-1.1,1.1h-4.8v-10.7l-5.5-5.5v-8.7l-7.1-7.1v-12.5l2.9-2.9v-3.8l-3.4-3.4v-30.3l-4.6-4.6v-6.9l7.8-7.8v-7.9l4.9-4.9-2.2-2.2v-4.5l-6.5-6.5v-29.3l9-9v-4.6l-9.4-9.4,4.8-4.8v-4l-3.9-3.9,7.2-7.2h2.6v-17l-2.6-2.6v-10.2l-8.5-8.5v-5.1l-3.5-3.5v-17.6h4.9v-6.6l4.2-4.2v-7.8l-5.2-5.2v-8.4l2.7-2.7v-12.5l4.6-4.6v-6.1l12.3-12.3-.6-.6v-5.1l-2.7-2.7v-4.4l2.3-2.3v-3.1l-5.4-5.4c-2.4-2.4-.5-6.2-.3-6.6v-.2c0,0,2.5-2.4,2.5-2.4v-1.6l-3.6-3,1.7-5.7,18.2-9.7,3.4-15.2v-4.8h-.7l-1.6,1.6h-5.7l-11.8-32.3-13.2-13.2,6.5-6.5-3.4-3.4,2.9-2.9v-1.2l-11.1-11.1v-12.8l-4.5-4.5v-2.7l-2.4,2.4,3,3-6.4,6.4-1.7-1.7-5.8,6.1-.7-.7v257.2l10.9,10.9-11.5,11.5-10.4,61.3-6.7-1.4v13.9l14.8,14.8v26.2l-5.9,5.9v17.1l19.7,19.7v40.4l14.3,14.3-9.1,9.1v33.7h-6.4v-11.4h-4.9v-7.7h-13.8v9l-8.5,8.5,7.1,7.1,6.8-6.8,3.2,3.2h7.6v13.2l7.8,7.8h9.5l-3.4,3.4h-10v5.9l4.1,4.1h5.2l-3.2,3.2v5.4h-2.2v6l4.6,4.6v4.6l2.9,2.9v-10.1l2.9-2.9,2.7,2.7-1.5,1.5v8.3h2.4l-6.4,6.4v13.5l7.4,7.4,4.3,4.3h-3.6v4.3l4.8,4.8h3.6v5.4h-3.9v2.2l8.7,8.7h2v-7.8l3.5,3.5,2-2v-2.2l-2.6-2.6-2.3-2.3h10.2l4.3,4.3v3.6l-2.3,2.3v1.9l3.1,3.1-5.2,5.2v-9.8l-3.3,3.3v5l-3.7-3.7-5.1,5.1v7.5h5.3l2.7,2.7-4,4h3.6l3.7,3.7,2.6-2.6v-5.5l-3.2-3.2,3.4-3.4h19.8v2.5l-3.2,3.2-3.2-3.2-6.8,6.8h-3.4l-1.9,1.9.8.8-2.5,2.5,1,1,1.2,1.2-1.7,1.7v1h2.7l1.8,1.8,3,3,1.3-1.3v-2.2l2.3-2.3,1.3-1.3-2.7-2.7.9-.9h4.1l3-3v-.9l4.3-4.3.7.7,1.5,1.5h2.8v1.4h-2.3v1.6l-1.5,1.5v2.1l-2.7,2.7v2.9l1.8,1.8-4.8,4.8-1.1-1.1v-2.2l1-1v-3.8l-1.2,1.2v2.2h-4.1l-.6.6,2,2v1.2l4.3,4.3h4.2l3,3h2.9l.8.8,4.3-4.3-4.2-4.2,3-3v-17.9l3.4-3.4,3.8-3.8h5.5l1.1-1.1v-4.5l2-2h5.1l2,2,1.1-1.1-2.1-2.5.2-.3Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1014.5 1660.8 1018.9 1673.8 1022.4 1670.9 1019.8 1665.8 1014.5 1660.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1018.4 1679 1025.9 1707.6 1031.5 1706.5 1040.8 1706.5 1040.8 1709.2 1034.7 1709.2 1026 1709.2 1026 1715.1 1034.2 1712.3 1039.6 1712.3 1051.8 1712.3 1057.1 1717.6 1062.3 1717.6 1065.5 1714.4 1065.5 1710.9 1070 1710.9 1071.4 1712.2 1074.7 1708.9 1074.7 1707 1071.8 1707 1067.3 1707 1062.2 1707 1059.2 1704 1052.3 1704 1052.3 1700.4 1036.1 1694.8 1036.1 1691.3 1032.4 1687.6 1027.7 1687.6 1024.4 1679.3 1018.4 1679"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "673.9 316.3 673.9 323.8 691.4 320.2 701.2 311.7 716.1 311.7 710.2 317.5 726.8 317.5 726.8 323.7 738.4 323.7 746.6 332 765.2 332 765.2 340 773.5 348.4 789.6 348.4 789.6 353.6 781.7 361.4 784.6 361.4 803.3 361.4 815.8 361.4 820.7 356.5 832.4 356.5 824.4 348.5 811.9 348.5 811.9 339.2 804.8 339.2 799.7 334.1 794.9 334.1 791 330.3 787.7 333.6 774.6 333.6 762.6 321.6 756.1 321.6 746.4 311.9 732.1 311.9 722.1 301.9 706.1 301.9 702.7 305.3 687.6 305.3 673.9 316.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "872 364.2 863.7 364.2 863.7 361.3 856.9 361.3 855 363.2 846.1 363.2 848.8 365.9 857.4 365.9 857.4 378.3 863.3 384.1 862 385.4 828.9 385.4 828.9 387.4 835.4 387.4 839.2 391.3 841 389.5 852.8 389.5 860.8 389.5 864.9 393.7 873.1 401.8 881.2 393.7 876.9 389.4 880.3 386 884.1 389.7 887.5 386.3 890.5 389.3 896.4 389.3 899.7 386.1 909.2 386.1 912.2 383 915.5 386.3 922.5 386.3 926.7 382.1 924.7 380.2 920.7 376.2 910.5 376.2 904.8 376.2 901.2 372.5 896.4 372.5 896.4 369.9 902.9 369.9 905 371.9 913.8 371.9 913.8 369.6 906.2 369.6 902.3 365.7 898.7 365.7 898.7 363.5 883.7 363.5 880.9 363.5 878.6 361.3 872 364.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "936.9 670.3 939.4 670.3 939.4 667.6 936.9 665.1 936.9 670.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "880 494.1 880 494.1 880 494.1 880 494.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "545 450.9 541.2 447.1 541.2 440.5 555.3 426.4 579.7 426.4 579.7 419.1 575.9 419.1 553.6 396.8 567 396.8 567 385.5 567 381.4 605.6 381.4 605.6 378 613.6 378 613.6 370.3 628.5 355.4 628.5 362.8 632.8 367.1 636.9 363 636.9 346 634.1 346 634.1 336.7 638.2 332.7 638.2 321.9 649.7 310.4 649.7 301.4 641.1 292.7 637.3 296.5 612.5 296.5 609.5 299.5 575.1 313.3 575.1 335.8 568.8 342 568.8 351.8 558.2 362.4 558.2 369.1 555.2 372.1 544.9 372.1 544.9 367.9 530.1 367.9 530.1 374.8 519.2 374.8 510 374.8 504.9 379.9 488.7 379.9 480 371.2 461.3 371.2 441.1 351 424.8 334.7 424.8 322.2 409.9 307.3 409.9 258 416.7 251.2 416.7 227.2 431.3 212.6 431.3 206.3 409 206.3 386.5 206.3 386.5 191.4 375 179.9 365.7 170.7 365.7 154.8 352.1 141.2 339.1 128.2 321.3 128.2 312.9 136.6 307.7 141.8 300 141.8 282.1 123.9 282.1 112.6 247.9 78.5 215.1 78.5 215.1 85.4 160.8 85.4 149.9 74.6 136 74.6 85.4 40.2 52.1 39.7 52.1 104 94.6 146.5 75 146.5 102.4 173.8 109.4 173.8 128.5 192.9 128.5 212.5 123.4 217.6 123.4 225.7 166.9 269.2 176.2 259.8 151.2 234.8 156.9 229 140.1 212.1 140.1 186.3 134.8 186.3 134.8 172.5 117.8 155.4 117.8 141.9 89.4 113.5 89.4 80.8 85.2 76.6 85.2 55.1 101.9 71.8 106.3 67.4 121 82.1 121 94.2 125.3 94.2 125.3 109.1 168.4 152.3 158.1 162.5 190.4 194.7 180.5 204.6 187.4 211.4 191.7 207.1 209.8 225.2 209.8 234.6 255 279.8 255 304.7 261 310.7 261 328.9 248.7 328.9 248.7 340.5 275 366.8 284.1 366.8 297.5 380.2 307.6 390.3 333.8 390.3 355.7 412.1 377 412.1 408.9 444 452.9 444 477.9 419 504.7 419 544.9 459.1 545 459.1 545 450.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "607.8 398.3 607.8 387.3 601.5 387.3 601.5 391.8 596.5 396.8 594.6 394.9 591.6 397.9 592.1 397.9 592.1 426.2 595.6 426.2 595.6 426.2 599.4 422.4 601.5 424.4 606.9 418.9 606.9 408.2 604.9 406.2 604.9 401.2 607.8 398.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "773.9 547.9 773.9 553.2 778.4 557.7 774.2 561.8 774.2 569.4 770.2 569.4 766.4 573.2 766 572.7 766 579.6 772.2 585.8 772.2 617.9 781.6 627.4 762 647 758.6 650.4 748.9 660.1 748.9 668 750 666.9 761.4 678.3 767.3 678.3 771.6 682.6 771.6 685.5 777.2 685.5 783 691.3 788.7 691.3 788.7 686.7 792.5 682.9 798.7 682.9 808.6 692.7 808.6 693.6 818.2 693.6 826.3 701.7 826.3 712.2 834.3 712.2 838.7 716.6 838.7 721.1 844 726.3 844 732.3 856.9 732.3 865.1 724.1 872.3 731.3 879.4 724.2 887.9 732.6 891.6 729 891.6 735.6 881.8 751.7 881.8 752.1 889.6 752.1 892.3 754.8 903.6 717.8 903.6 709.4 891 696.8 891 690.7 902.2 679.5 902.6 679.9 905.7 676.8 903.3 674.5 900.3 674.5 895.4 669.5 895.4 662.3 914 662.3 916.3 660 920 660 922 661.9 925.9 657.9 929.9 657.9 936.4 664.3 936.4 660.7 931.5 655.9 935.3 652.1 931.2 648.1 927.9 648.1 923.1 643.3 934.1 632.2 925.5 623.6 925.5 600.9 932.4 600.9 932.4 588.8 920.1 588.8 915.5 593.4 910.9 588.8 905.6 588.8 892 575.3 882 575.3 878.6 578.7 875.7 575.9 858.2 575.9 848.7 566.3 856.2 558.7 856.2 554.2 844.5 542.5 844.5 540 835.6 540 842.7 533 842.7 526.9 838.9 523.2 851.1 511.1 851.1 506.4 863 494.5 871.3 494.5 871.3 492.6 878.5 492.6 871.2 485.3 865.7 490.8 857.5 490.8 857.5 495.5 846.5 506.5 829.2 506.5 829.2 513.1 825.9 516.4 823.7 514.2 823.7 510 816.2 510 801.1 525.1 804.6 528.6 804.6 535.1 798 535.1 786.2 546.9 783.4 549.7 786.6 553 786.6 560.9 782.1 560.9 776.9 555.7 776.9 550.9 773.9 547.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1141.7,607.6v3.8l2.7,2.7v6l7.1,7.1v8.8l-3,3v9.2l-4.5,4.5h0v3l3.5,3.5,5.3-5.3,6.7,6.7,16.6-16.6v-8.5l11.5-11.5h-.9v-4.1l-18-18h-9.4l-2.4-2.4s-4.5.3-7.2.2l-7.9,7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1102,603.6l-6.2,6.2h-4.8v2.7l-7.5,7.5v1.4h4l8,8v2.9h4.5v13.4l14.4,14.4h4.5v-3.4l-6.7-6.7,5.8-5.8h19.9l5.2,5.2,2.5-2.5v-9.2l3-3v-6.3l-7.1-7.1v-6l-2.7-2.7v-6.3l8.8-8.8c0-.9.2-1.9.2-1.9h-10.4l-5.5-5.5-3.5,3.5h-23.8l-2.5,1.2v8.8h-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "886.4 504.5 872.5 518.4 872.5 531 875.5 534 866.1 543.4 861.8 543.4 861.8 535.6 857.7 531.5 869.5 519.7 858.1 508.3 864 502.4 871.6 502.4 878.5 495.6 874.3 495.6 874.3 497.5 864.3 497.5 854.1 507.6 854.1 512.3 843.2 523.2 845.7 525.7 845.7 534.2 842.9 537 847.5 537 847.5 541.2 859.2 552.9 859.2 560 852.9 566.3 859.5 572.9 877 572.9 878.6 574.4 880.7 572.3 893.3 572.3 906.8 585.8 912.2 585.8 915.5 589.1 918.9 585.8 935.4 585.8 935.4 603.9 928.5 603.9 928.5 622.4 938.4 632.2 927.4 643.3 929.2 645.1 932.5 645.1 939.5 652.1 935.8 655.9 939.4 659.5 939.4 663.3 942.4 666.4 942.4 671.2 951.7 680.4 962.1 680.4 985.9 656.6 997.4 656.6 995.6 654.8 978.5 654.8 978.5 639.5 983.6 634.3 969.7 620.4 984.3 620.4 989.3 625.5 1005 625.5 1015.4 615.1 1020.7 620.4 1031.9 620.4 1040.4 611.9 1040.4 604.4 1026.6 590.6 1037.5 579.8 1047.5 579.8 1047.5 575.5 1040.1 575.5 1040.1 565.7 1044.8 561 1048.4 561 1057.3 552.1 1052.7 552.1 1045.9 545.3 1039.8 551.4 1022.6 551.4 1022.6 548.2 1030 548.2 1035.9 542.3 1035.9 535.3 1029.6 535.3 1023.7 529.4 1013.6 529.4 1006.4 522.2 1006.4 519.6 1020.3 519.6 1020.3 515.4 989.3 515.4 969.1 525 960.2 516.1 926.7 516.1 926.7 509.6 921.5 504.4 910.2 504.4 907.6 501.9 899.5 501.9 899.5 490 895.7 486.2 886.6 495.2 886.6 500.4 893.6 500.4 893.6 504.5 886.4 504.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "571.7 462.2 576.5 457.3 581.9 457.3 581.9 456.1 588.6 449.4 588.6 445.2 595.2 438.6 599 438.6 603.7 433.9 600.7 433.9 595.6 428.7 595.6 429.2 589.1 429.2 589.1 398.9 567.3 398.9 567.3 399.8 560.9 399.8 577.1 416.1 582.7 416.1 582.7 429.4 556.5 429.4 544.2 441.7 544.2 445.9 548 449.6 548 459.4 554.6 466 565.7 466 571.7 466 571.7 462.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1061.1 552.6 1049.7 564 1046.1 564 1043.1 566.9 1043.1 572.5 1050.5 572.5 1050.5 582.8 1038.7 582.8 1030.9 590.6 1042.5 602.3 1051.2 602.3 1055.7 606.8 1055.7 613.6 1052.5 616.7 1056.7 616.7 1063.9 623.9 1058.9 629 1058.9 633.7 1054.3 638.2 1054.3 654.1 1071.2 671 1078.3 671 1085.4 663.9 1091.1 663.9 1094.7 660.2 1110.1 660.2 1096.9 647.1 1096.9 635.4 1092.4 635.4 1092.4 630.7 1086.2 624.5 1080.4 624.5 1080.4 618.9 1088 611.3 1088 606.8 1094.5 606.8 1099 602.4 1099 596.3 1098.5 596.5 1098.5 586.1 1092 586.1 1084.1 578.3 1080.4 581.9 1076.3 586.1 1073.7 586.1 1073.7 576.6 1073.7 570.1 1065.7 562 1065.7 557.2 1061.1 552.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1126,1309.6v-5.4l5.1-5.1v-6.1l-7.9-7.9h-8.8v-9.3l-1,1.1-11.5-10.7v-9.2l6.6-6.6v-56.1l52.5-52.5h7.4v-18.5l-3.9-3.9v-5.5h-7.6v14.9l-26.4,26.4h-9.3l-5.7-5.7h-25.1v-5.6l6.2-6.2v-8.5l8.4-8.4v-3.6l-10-10h-10.6l-7.6-7.6h-5l-8.4-8.4h-12.4v-4.9l-3.7-3.7h-6.3l-11.7-11.7v-6.8h-3.1l-6.8-6.8h-16.3l-5,5v9.6l-8.7-8.7v-3.6h-18l-3.8-3.8h-1.6l-5.7,5.7v4.5l-5.5,5.5v6.1l-3.8,16.7-18.3,9.7-.8,2.6,3.1,2.6v4.2l-2.9,2.9c-.4.8-.8,2.4-.2,3l6.3,6.3v5.6l-2.3,2.3v1.9l2.7,2.7v5.1l1.9,1.9-13.6,13.6v6.1l-4.6,4.6v12.5l-2.7,2.7v5.9l5.2,5.2v10.3l-4.2,4.2v8.4h-4.9v13.4l3.5,3.5v5.1l8.5,8.5v10.2l2.6,2.6v21.3h-4.3l-4.2,4.2,2.7,2.7v6.4l-3.6,3.6,8.1,8.1v7.1l-9,9v26.8l6.5,6.5v4.5l3.4,3.4-6.1,6.1v7.9l-7.8,7.8v4.5l4.6,4.6v30.3l3.4,3.4v6.3l-2.9,2.9v10l7.1,7.1v8.7l5.5,5.5v8.9h.6l2.3-2.3,3.5,3.5v5.4l-4.2,4.2h-7.8l-.3.3,1.2,1.2,1.3-1.3h5.3l9.4,9.4v6.8l-4.4,4.4v13.8l6.1,6.1-5.6,5.6v2.4l5.8,5.8-6.1,6.1v16.1l3.3,3.3v10.6l-11,11v13.8l-2.5,2.5v6.7l7.7,7.7h1.7l6.4-6.4h7.1v15.3l4,4v3l1.8,1.8v5.7h9.1l2.1,2.1,2.7-2.7h30.1l2.2,2.2h3.4l4.3,5.2-.7.6,2.4,2.4v-3.2l-6.9-6.9v-2.4l-2.9-2.9h-3l-1.5-1.5,1.6-1.6v-5.1l-8.4-8.4v-10.1l7.1-7.1v-7.9l5.7,5.7,10.3-10.3v-7.2h-7.3l5.9-5.9v-5.1l3.4-3.4h2.9v-4l3.5-3.5h2v-2.9l4.4-4.4v-3l1.5-1.5-1.7-1.7h-2.1l3-3v-11.1h-13.5l-10-10h-3.2l-3.4-3.4-4.3-4.3v-4.2l-1.9-1.9v-3.1l17.3-17.3h14.2v-2.7h-4.9v-5.1l4-4,2.7-2.7-4.6-4.6v-17.5l2.8-2.8h4.5l4.3-4.3v-1.8h-7.4l-2.7-2.7,2.6-2.6,4.1-4.1h3.3l3.1,3.1v4.8l2.4,2.4,5.2-5.2,2.5-2.5-4.8-4.8,1.7-1.7v-3.9l-2.2-2.2-4.6,4.6v2.5h-5.5v-2.4h-5.6l-3.8-3.8v-13.2l-5.2-5.2v-6.4l3.7-3.7h3.4v3.1h8.3l6.2,6.2h13.8l6.6-6.6v-4l3.2-3.2-2.4-2.4-3-3v-7.1l4.3-4.3v-3.9h-2.8v-10.2l-2.5-2.5v-2.1l1.8-1.8,2,2h4.2l5.4,5.4h3.5l3.1-3.1h5.8l2,2h5.9l39-18.4v-10.1l8.8-8.8v-10.9h-6.8l-7.4-7.4h.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "610.9 473.9 610.9 461.3 606.6 461.3 606.6 466.2 599.9 459.4 592.1 459.4 587.5 454.8 584.9 457.4 584.9 460.3 577.8 460.3 574.7 463.4 574.7 466 577.2 466 580.8 469.6 585.9 469.6 591.9 475.6 595.4 475.6 592.8 473 594.6 471.2 598.3 471.2 602.8 475.7 609.7 475.7 611.6 473.9 610.9 473.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "1179.5 1253.4 1185.1 1247.8 1185.1 1243 1172.9 1230.8 1164.2 1230.8 1164.2 1223.5 1160.1 1219.4 1153.7 1219.4 1146.4 1212 1142.6 1215.8 1126.4 1199.7 1111.5 1199.7 1111.5 1251.5 1104.9 1258.1 1104.9 1264.7 1115.4 1274.6 1114.4 1275.6 1120 1281.1 1132.2 1281.1 1141.9 1281.1 1141.9 1288.2 1146.4 1283.8 1155.5 1283.8 1157.7 1286.1 1164.8 1286.1 1166.6 1284.2 1170.3 1284.2 1172.6 1281.8 1183 1271.4 1183 1266.2 1186.3 1263 1187.7 1261.6 1179.5 1253.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1439 776.1 1425.7 776.1 1389.1 739.5 1344.8 739.5 1325.6 720.3 1306.3 739.6 1298.8 747.1 1301 728.6 1298.2 728.6 1303 723.9 1295.7 716.5 1289.8 716.5 1287.9 718.5 1285.7 718.5 1281.2 714 1276.1 709 1269.5 709 1265.5 709 1259.3 702.8 1253.6 702.8 1251.2 705.2 1249.3 703.3 1246 703.3 1242.8 706.5 1242.8 711 1235.6 718.2 1229.6 718.2 1229.6 721 1223.5 727.2 1223.5 732.2 1218.9 736.7 1221.2 739 1221.2 747.6 1219.3 747.6 1213.4 741.7 1213.4 737.5 1218.3 732.6 1218.3 727.6 1221.4 724.5 1219.3 722.3 1214.9 726.7 1212.6 724.4 1204.7 724.4 1202.1 721.8 1204.7 721.8 1207.3 719.3 1214.1 719.3 1217.4 719.3 1221.3 715.3 1223.5 717.5 1227.3 713.7 1232.2 713.7 1232.2 710.5 1238.2 704.4 1238.2 696.4 1234 696.4 1231.2 693.5 1226.9 693.5 1222.8 697.6 1218 697.6 1214.1 693.7 1207.9 693.7 1202.2 699.4 1204.8 702 1200.7 706.1 1198.4 706.1 1189.7 714.9 1184.8 714.9 1191.8 707.9 1191.8 704.9 1181.7 714.9 1177.5 714.9 1183.5 708.9 1179.8 705.2 1189 696 1199.7 685.3 1213.4 671.6 1210.5 668.7 1213.5 665.7 1200.5 652.6 1200.5 643.6 1191.5 634.7 1191.5 624 1190 624 1190.9 624.9 1179 636.7 1179 645.2 1159.4 664.9 1152.7 658.2 1147.4 663.5 1141 657 1141 651.8 1136.5 647.3 1119.1 647.3 1116.3 650.2 1121.8 655.6 1121.8 663.2 1096 663.2 1092.3 666.9 1086.7 666.9 1079.5 674 1070 674 1051.3 655.4 1051.3 637 1055.9 632.4 1055.9 627.7 1059.7 623.9 1055.4 619.7 1045.3 619.7 1052.7 612.3 1052.7 608 1049.9 605.3 1043.4 605.3 1043.4 613.1 1033.1 623.4 1019.5 623.4 1015.4 619.3 1006.2 628.5 988 628.5 983 623.4 977 623.4 987.9 634.3 981.5 640.7 981.5 651.8 996.9 651.8 1004.6 659.6 987.1 659.6 963.4 683.4 950.4 683.4 940.3 673.3 933.9 673.3 933.9 666.1 928.7 660.9 927.2 660.9 922 666.1 918.8 663 917.6 663 915.2 665.3 898.4 665.3 898.4 668.3 901.6 671.5 904.6 671.5 909.9 676.8 906.1 680.6 907.8 682.2 907.8 689.3 902.2 683.8 894 692 894 695.6 906.6 708.2 906.6 718.2 893.7 760.6 893.7 765.9 892.1 765.9 890.7 770.5 890.7 765.9 886.4 765.9 881.8 761.3 879.2 761.3 879.2 764.2 866.6 764.2 860.1 770.8 854.2 770.8 846 778.9 846 787.2 841 792.3 841 799.6 834.8 805.7 834.8 822.5 848.5 836.2 841.7 843 853.5 843 859.2 848.7 859.2 853.5 872 853.5 883.5 842 890.1 848.5 884.6 853.9 884.6 871.9 901.4 871.9 902 872.5 916.9 872.5 922.6 866.8 927.9 866.8 944.9 849.8 969.5 849.8 969.5 876.2 987.4 894 987.4 891.9 996.9 891.9 1001.5 896.5 1010.3 896.5 1010.3 903.9 1028.8 903.9 1028.8 908.7 1036 915.9 1043 908.9 1053.3 919.2 1053.3 935.9 1048.5 940.7 1056.1 948.4 1056.1 955.2 1085.1 955.2 1085.1 974.6 1091.4 974.6 1104.2 987.5 1104.2 1000.2 1094.9 1009.5 1094.9 1015.8 1092 1018.7 1100 1026.7 1100 1059.8 1119.9 1059.8 1129.1 1050.6 1141.2 1062.7 1141.2 1085.5 1144.1 1088.4 1151.3 1081.2 1156.9 1086.8 1156.9 1110.7 1167.5 1110.7 1167.5 1118 1171.4 1121.9 1171.4 1144.6 1162.2 1144.6 1111.5 1195.3 1111.5 1196.7 1127.7 1196.7 1142.6 1211.6 1146.4 1207.8 1155 1216.4 1161.3 1216.4 1167.2 1222.3 1167.2 1227.8 1174.1 1227.8 1188.1 1241.8 1188.1 1249 1183.7 1253.4 1189.8 1259.5 1192.2 1257.1 1194.2 1252.4 1200.1 1232.4 1195.8 1228 1197.2 1226.8 1197.2 1223.4 1199.3 1221.3 1203.3 1217.3 1203.3 1214.6 1204.9 1214.6 1206.7 1216.3 1209.5 1213.5 1209.5 1209.1 1211.4 1207.2 1211.4 1204.6 1213.2 1202.9 1215.2 1200.8 1215.2 1198.7 1213.1 1196.6 1213.1 1193.1 1210.7 1190.7 1211.5 1189.9 1215.2 1189.9 1215.2 1193.8 1219.6 1198.2 1223.5 1198.2 1223.5 1202.6 1221.6 1202.6 1221.6 1208.1 1217.5 1214.5 1214.2 1214.5 1214.2 1218.5 1211.7 1221 1209.6 1221 1206 1224.7 1206 1226 1202.4 1226 1202.4 1227.9 1204.2 1229.7 1214.5 1222.3 1220.6 1214.8 1229.3 1200.2 1229.3 1197 1232.4 1188.7 1239.7 1174.8 1247.8 1164.1 1252.2 1155.3 1252.2 1150 1252.2 1147.2 1245 1125.2 1250.8 1125.2 1250.8 1116.2 1247.9 1113.3 1298.8 1062.3 1347.9 1062.3 1364 1046.2 1383.1 1008 1383.1 987.1 1391 979.2 1391 897.2 1401 897.2 1412.1 897.2 1412.1 878.3 1428.3 862 1461.7 828.6 1461.7 798.9 1439 776.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "946.1 852.8 929.2 869.8 923.8 869.8 918.1 875.5 905 875.5 920.7 891.2 912.9 899 912.9 949.9 920.6 957.6 920.6 962.3 908.6 974.2 908.6 976.2 912.4 976.2 912.4 985 917 989.5 917 1002.3 928.1 1013.4 928.1 1017.1 926.5 1018.7 929.8 1022.1 923.3 1028.6 934.8 1040.1 934.9 1040.5 946.1 1071.1 948.4 1071.1 950 1069.6 952.8 1069.6 957.4 1065 957.4 1060.5 964.9 1053.1 969 1053.1 972.8 1056.9 992.6 1056.9 992.6 1062.2 995.3 1064.9 995.3 1061.3 1002 1054.5 1018.9 1054.5 1020.9 1044 1020.9 1029.5 1031.5 1018.8 1031.5 1008.1 1054.6 1008.1 1057.5 1005.3 1078.6 1005.3 1089.9 1016.6 1091.9 1014.6 1091.9 1008.3 1101.2 998.9 1101.2 988.7 1090.1 977.6 1082.1 977.6 1082.1 958.2 1053.1 958.2 1053.1 949.6 1044.2 940.7 1050.3 934.7 1050.3 920.4 1043 913.1 1036 920.2 1025.8 910 1025.8 906.9 1007.3 906.9 1007.3 899.5 1000.2 899.5 995.7 894.9 990.4 894.9 990.4 901.3 966.5 877.4 966.5 852.8 946.1 852.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1077.3 1008.3 1058.7 1008.3 1055.8 1011.1 1034.5 1011.1 1034.5 1020 1023.9 1030.7 1023.8 1044.4 1021.8 1055.5 1027.6 1061.3 1032.4 1061.3 1032.4 1069.8 1042.3 1079.8 1048.6 1079.8 1054.1 1085.2 1054.1 1088.4 1064.7 1088.4 1073.1 1096.7 1078 1096.7 1085.6 1104.3 1096.2 1104.3 1107.9 1116 1107.9 1122.1 1099.5 1130.4 1099.5 1138.9 1093.4 1145 1093.4 1146.4 1116.7 1146.4 1122.4 1152.1 1129.2 1152.1 1153.9 1127.4 1153.9 1088 1151.3 1085.4 1144.1 1092.6 1138.2 1086.7 1138.2 1064 1129.1 1054.8 1121.1 1062.8 1097 1062.8 1097 1027.9 1077.3 1008.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "638.8 506.7 641.3 506.7 641.3 505.3 650.3 505.1 654.9 509.7 666.1 509.7 672.2 515.8 676.9 515.8 673.4 505.6 675.7 499.1 673.2 500.2 673.2 482.4 677.9 482.4 677.9 488.2 679.9 488.2 679.9 471.1 678 469.1 686.4 460.7 686.4 446.4 677.8 446.4 671.3 452.8 664.2 452.8 662.4 451.1 648.4 465 642.9 465 639.9 462 636.4 462 631.9 466.5 629.5 466.5 629.5 473.8 625.4 477.8 617.9 478.7 617.6 475.7 624.1 474.9 626.5 472.5 626.5 463.5 630.6 463.5 635.1 459 641.1 459 644.2 462 647.2 462 662.4 446.8 665.4 449.8 670.1 449.8 676.6 443.4 686.4 443.4 686.4 441.7 681.4 436.7 681.4 440.6 666.2 440.6 666.2 434.6 676.1 434.6 673.1 431.6 660.8 431.6 646.9 431.6 640.8 425.5 635.8 430.5 612.3 430.5 608.9 433.9 606.1 433.9 607 434.8 600.3 441.6 596.5 441.6 591.6 446.5 591.6 450.7 589.6 452.7 593.3 456.4 601.1 456.4 603.6 459 603.6 458.3 613.9 458.3 613.9 472.9 617.4 472.9 617.4 476.5 617.4 479.3 613.9 479.3 622.4 487.9 622.4 490.3 638.8 506.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "686.6 554.6 686.6 548.1 688.2 546.6 684.2 542.6 690.2 536.5 689.9 536.2 693.6 532.5 679 518 679 518.8 670.9 518.8 664.8 512.7 653.7 512.7 649.1 508.2 641.5 508.3 641.5 513.4 643 514.9 643 518.5 641.3 520.2 638.7 522.8 638.7 526.8 643 531.2 648.3 531.2 649.9 532.8 652.3 535.1 655.7 531.7 653.6 529.6 648.5 524.5 651.2 521.9 656.4 527.1 656.4 528.8 673.9 546.3 671.9 548.2 671.9 551.9 674.9 551.9 678.7 555.7 681.1 553.3 676.9 549 678.5 547.5 683.1 552.1 683.1 555.7 686 558.6 687.4 557.3 687.4 554.6 686.6 554.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "712.5 565.7 715 565.7 715 563.2 714.2 562.3 714.2 559.9 716.9 559.9 719.4 562.4 719.4 570.5 720.7 571.8 723.3 571.8 727.9 567.3 732.2 567.3 732.2 564.5 727.6 559.8 725.5 557.7 725.5 555.8 728.1 553.2 734.3 553.2 738.5 549 738.5 547.9 737.4 546.8 737.4 544.6 741.8 540.2 748.2 540.2 752.6 544.6 754.2 544.6 758.1 548.5 758.1 552.1 759.4 553.4 762.5 550.3 764.6 550.3 764.6 553.6 762.2 553.6 757.3 558.5 760.1 561.4 760.1 564.6 765.5 569.9 769 566.4 771.2 566.4 771.2 560.6 774.1 557.7 770.9 554.5 770.9 546.3 772.3 546.3 769.7 543.7 766.8 540.7 761.2 535.2 747.4 535.2 744.1 531.8 738.8 537.1 732.7 537.1 728.6 541.3 722.7 541.3 719.4 544.6 711.8 544.6 698.3 544.6 692.3 538.6 688.4 542.6 692.4 546.6 689.6 549.4 689.6 554.3 696.2 554.3 698 552.4 700 554.4 700 556.2 706.6 556.2 706.6 559.7 712.5 565.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "945.9 385.7 942.3 389.3 942.3 394.7 952.5 394.7 960.1 394.7 968.5 389.3 964.4 385.1 955.3 385.1 945.9 385.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "790.7 385.4 778.6 385.4 771.2 386.4 766.3 386.4 764.6 388.1 767.6 391.1 771.7 391.1 776 395.4 779.6 395.4 782.5 398.4 785 398.4 785 395.9 789.9 395.9 792.4 393.4 795.4 396.3 800.1 396.3 800.1 390.8 793.6 390.8 790.7 385.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M732.9,730.8v16.1l-3.5,3.5,1.4,1.4h0l4.4,4.4h-6.5l-2.4,2.4v2.1h9.2v5.3h5.3l5.6,5.6h1.4l14.7-27.7c2.5-3.4,3.2-3.3,3.8-3.3h.4c1.2-.3,5.4-1.7,9.3-3.1v-2.6h5.9l21.5-21.5v-4h6.1v-7.9l-3.7-3.7v-3.8l-8-8h-3.8l-2.1,2.1v6.3h-9.9l-5.8-5.8h-7.4v-4.7l-2.5-2.5h-6l-12.2-12.2-2.3,2.3h-3.3l-7.2,7.2h-8.5v5.1l5.7,5.7-9.2,9.2v5.2l-8.7,8.7v17.7l9.6,9.6,9-9h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M917.6,961v-2.2l-7.7-7.7v-53.4l6.6-6.6-16.3-16.3h-18.5v-22.2l4.2-4.2-2.3-2.3-10.3,10.3h-17.1v-6.6l-4-4h-17.8l9.8-9.8-12.4-12.4v-19.2l6.2-6.2v-7.3l5.1-5.1v-8.3l9.9-9.9h5.9l6.5-6.5h10.8v-2.9h6.9l4.6,4.6h3v-5.6l-2.3-2.3h-9.6v-4.2l8.7-14.3-8.1-8.1-7.1,7.1-7.2-7.2-7,7h-17.2v-7.7l-5.2-5.2v-4.5l-2.7-2.7h-9.7v-12.2l-6.3-6.3h-8.4l3.6,3.6v12.1h-6.1v2.3l-23.3,23.3h-4.1v1.7l-1,.4c-7,2.7-10,3.6-11.4,3.7-.4.4-1,1.2-1.6,1.9l-15.4,29h-4.5l-5.6-5.6h-7.1v-5.3h-9.2v-6.3l4.2-4.2h.3l-.7-.7h-7l-11.4,11.4v13.7l9.1,9.1h-7.6v8.1l7.4,7.4h12.5l10.2,10.2v8.7l55,98.9,44,44h21.8l33.3,33.3,7.6-7.9,1.7,1.7,2.2-2.2-3-3,4.6-4.6-1.8-1.8v-6.4l12-12h.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M266.1,226.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,360.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,226.7h10.6v10.6h-10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.9,226.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M266.1,350.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M327.6,226.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M420.2,216.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M348.2,226.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M399.6,216.7v10.1h10.6v10.6h-10.6v10.1h-10.1v-10.1h-10.6v-10.6h10.6v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M368.9,226.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M378.9,216.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,237.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M317.5,237.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M358.8,237.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M358.8,216.7v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M378.9,237.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M338.1,216.7v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M410.1,206.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M410.1,237.3h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M255.6,340v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M296.9,319.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M255.6,319.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M245.5,257.9h-10.6v-10.6h10.6v10.6h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M266.1,247.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M389.5,206.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,247.4h10.6v10.6h-10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.9,247.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M368.9,206.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M317.5,247.4h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M348.2,247.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M338.1,206.6h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M368.9,247.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M327.6,206.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M389.5,247.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.9,216.7h-10.1v-10.1h10.1v10.1h10.6v10.1h-10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M410.1,247.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M266.1,216.7h-10.6v-10.1h10.6v10.1h10.1v-10.1h10.6v10.1h-10.6v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,257.9v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M296.9,298.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M296.9,257.9v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,298.7v10.6h10.6v10.1h-10.6v10.6h10.6v10.1h-10.6v10.6h-10.1v-10.6h-10.6v-10.1h10.6v-10.6h-10.6v-10.1h10.6v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M317.5,257.9v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M255.6,298.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M338.1,257.9v10.1h10.1v10.6h-10.1v10.1h10.1v10.1h-10.1v10.6h10.1v-10.6h10.6v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h10.1v10.1h10.6v10.6h-10.6v10.1h10.6v10.1h-10.6v10.6h10.6v-10.6h10.1v10.6h10.6v-10.6h-10.6v-10.1h10.6v-10.1h-10.6v-10.6h10.6v-10.1h10.1v51.4h10.6v10.1h-10.6v10.6h10.6v10.1h-10.6v10.6h10.6v-10.6h10.1v10.6h10.1v10.1h10.6v10.1h61.4v-10.1h20.6v10.1h10.6v-20.2h10.1v-20.6h10.6v-20.6h10.1v-10.6h20.6v10.6h10.1v-10.6h-10.1v-10.1h51.4v10.1h-10.1v10.6h10.1v10.1h-10.1v51.4h-10.6v-10.1h-10.1v10.1h-10.6v10.6h-10.1v10.1h-30.7v-10.1h-10.6v10.1h10.6v10.6h-10.6v10.1h20.6v20.6h-30.7c0-1,.5-10.1,0-10.1h-10.6v10.1h10.6v10.1h-10.6v10.6h10.6v10.1h-20.6v-10.1h-10.6v-10.6h-10.1v-20.2h-30.7v10.1h-10.6c0-1,.5-10.1,0-10.1h-10.1v10.1h10.1v10.1h-10.1v10.6h-30.7v-10.6h-10.6v10.6h-20.6v-10.6h-10.1v-20.2h-41.3v-10.6h-10.1v-10.1h-10.6v-20.6h-10.1v10.1h-20.6v-10.1h-10.1v-20.6h-10.6v-10.1h10.6v-10.6h10.1v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.6h-10.1v-10.1h10.1v-10.6h10.6v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h10.6-.2ZM327.6,329.9v-10.6h-10.1v10.6h10.1v10.1h-10.1v10.6h10.1v-10.6h10.6v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.6h-10.1v10.6h-10.6ZM368.9,319.4h-10.1v10.6h10.1v-10.6ZM389.5,319.4h-10.6v10.6h10.6v-10.6ZM410.1,319.4h-10.6v10.6h10.6v-10.6ZM615.6,319.4h-10.1v10.6h10.1v-10.6ZM368.9,340h-10.1v10.6h10.1v-10.6ZM389.5,340h-10.6v10.6h10.6v-10.6ZM594.9,340h-10.1v10.6h10.1v-10.6ZM636.2,340h-10.1v10.6h10.1v-10.6ZM306.9,360.7h-10.1v10.1h10.1v-10.1ZM327.6,360.7h-10.1v10.1h10.1v-10.1ZM348.2,360.7h-10.1v10.1h10.1v-10.1ZM368.9,360.7h-10.1v10.1h10.1v-10.1ZM389.5,360.7h-10.6v10.1h10.6v-10.1ZM430.8,360.7h-10.6v10.1h10.6v-10.1ZM594.9,360.7h-10.1v10.1h10.1v-10.1ZM368.9,381.3h-10.1v10.1h10.1v-10.1ZM410.1,381.3h-10.6v10.1h10.6v-10.1ZM450.9,381.3h-10.1v10.1h10.1v-10.1ZM492.2,381.3h-10.1v10.1h10.1v-10.1ZM533.5,381.3h-10.6v10.1h10.6v-10.1ZM368.9,401.9h-10.1v10.1h10.1v-10.1ZM410.1,401.9h-10.6v10.1h10.6v-10.1ZM450.9,401.9h-10.1v10.1h10.1v-10.1ZM492.2,401.9h-10.1v10.1h10.1v-10.1ZM533.5,401.9h-10.6v10.1h10.6v-10.1ZM430.8,422.6h-10.6v10.1h10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.9,288.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M358.8,257.9v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M430.8,206.6v-10.6h10.1v10.6h-10.1v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M410.1,206.6v-10.6h10.1v10.6h-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M399.6,257.9v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M389.5,196h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M245.5,268v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M378.9,196v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M266.1,268v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M338.1,196v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M286.8,268v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M378.9,185.9h10.6v10.1h-10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M306.9,268v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M368.9,185.9v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M338.1,185.9h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M327.6,185.9v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M255.6,278.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M286.8,288.7v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M276.2,278.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M327.6,175.4h-10.1v-10.1h10.1v10.1h10.6v-10.1h10.1v10.1h-10.1v10.6h-10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M296.9,278.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M266.1,288.7v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M317.5,278.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M368.9,175.4h-10.1v-10.1h10.1v10.1h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M399.6,278.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M358.8,278.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 255.6,
    y: 103.4,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 255.6,
    y: 124,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M224.9,216.7h-10.1v-10.1h10.1v10.1h10.1v-10.1h10.6v10.1h-10.6v10.1h10.6v10.6h-10.6v-10.6h-10.1v10.6h-10.1v-10.6h10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 132.2,
    y: 226.7,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 276.2,
    y: 144.7,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 234.9,
    y: 144.7,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 132.2,
    y: 206.6,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 152.9,
    y: 226.7,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 234.9,
    y: 165.3,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 152.9,
    y: 247.4,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 173.5,
    y: 247.4,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 214.8,
    y: 247.4,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 255.6,
    y: 144.7,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 276.2,
    y: 165.3,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 276.2,
    y: 185.9,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 255.6,
    y: 185.9,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 234.9,
    y: 185.9,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 132.2,
    y: 185.9,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 338.1,
    y: 124,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 173.5,
    y: 185.9,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 214.8,
    y: 185.9,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 173.5,
    y: 206.6,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 296.9,
    y: 165.3,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 296.9,
    y: 185.9,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 194.1,
    y: 165.3,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 358.8,
    y: 144.7,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 338.1,
    y: 144.7,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 317.5,
    y: 144.7,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 194.1,
    y: 144.7,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 296.9,
    y: 144.7,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 194.1,
    y: 206.6,
    width: 10.1,
    height: 10.1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1243.2,803v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1222.5,803v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1284.5,803v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1181.3,803v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,967.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1253.3,710.3v-10.1h10.6v10.1h-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.2,947v10.1h10.1v10.6h-10.1v10.1h10.1v10.6h-20.6v-20.6h-10.1v-10.6h10.1v-10.1h10.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1078.5,947v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1088.6,936.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1068.5,936.4v10.6h-10.6v10.1h-10.1v-10.1h10.1v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1181.3,926.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1109.3,823.6h-10.1v-10.6h10.1v10.6h10.6v-10.6h10.1v10.6h-10.1v10.1h-10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1150.5,823.6h-10.1v-10.6h10.1v10.6h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1171.2,813.1v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1232.6,792.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1181.3,813.1h10.6v10.6h-10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1212.5,813.1v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1212.5,792.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1232.6,813.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,792.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1253.3,813.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1171.2,792.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1273.9,813.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1253.3,710.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,710.3h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1181.3,823.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1140.5,926.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,823.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1294.5,720.4h-10.1v-10.1h10.1v10.1h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1222.5,823.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,926.3v10.1h10.1v10.6h-10.1v10.1h-10.6v-10.1h-10.1v-10.6h10.1v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1325.3,720.4v-10.1h10.6v10.1h-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,823.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.2,926.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,720.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1078.5,926.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1325.3,720.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1335.8,720.4h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1129.9,916.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1109.3,916.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,741.1h-10.6v-10.1h10.6v10.1h10.1v-10.1h10.6v10.1h-10.6v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1109.3,833.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1284.5,782.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,833.7h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1150.5,833.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,782.3v10.1h10.1v10.6h-10.1v10.1h-10.6v-10.1h-10.1v-10.6h10.1v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1171.2,833.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1243.2,782.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,833.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1222.5,782.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1212.5,833.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,782.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1294.5,772.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,844.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1160.6,844.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1273.9,772.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1181.3,844.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1253.3,772.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,844.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1232.6,772.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1222.5,844.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,772.3h10.6v10.1h-10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,772.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,844.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1171.2,782.3h-10.6v-10.1h10.6v10.1h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1088.6,916.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1232.6,741.1h-10.1v-10.1h10.1v10.1h10.6v10.6h-10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1068.5,916.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1253.3,731v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,731h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1294.5,731v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1140.5,905.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1315.2,731v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1088.6,864.4h-10.1v-10.1h10.1v10.1h10.6v10.6h-10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1109.3,854.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,905.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,854.3h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1150.5,854.3v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1335.8,731v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1171.2,854.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.2,905.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,854.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1345.9,731h10.6v10.1h-10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1212.5,854.3v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1345.9,761.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1304.6,761.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1284.5,761.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1119.8,864.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,761.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1140.5,864.4v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1243.2,761.7v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1160.6,864.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,761.7v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1181.3,864.4v10.6h10.6v10.1h-10.6v10.6h10.6v10.1h-10.6v10.6h-10.1v-10.6h-10.6v-10.1h10.6v-10.6h-10.6v-10.1h10.6v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1294.5,751.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,864.4v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1273.9,751.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1366.5,741.1v-10.1h30.7v10.1h-10.1v10.6h10.1v-10.6h10.6v10.6h10.1v10.1h-10.1v10.6h10.1v-10.6h10.6v10.6h20.2v10.1h10.6v10.1h10.1v41.3h-10.1v10.6h-10.6v10.1h-10.1v10.1h-10.1v10.6h-10.6v30.7h-20.6v82.6h-10.1v40.8h-10.6v20.6h-10.1v10.6h-10.1v10.1h-61.9v10.1h-10.1v10.6h-10.6v10.1h-10.1v10.6h-10.6v61.4h-10.1v20.6h-10.6v20.6h-10.1v10.1h-10.1v10.6h-10.6v30.7h-20.6v-30.7h-20.6v-10.6h-10.1v-10.1h-20.6v-10.1h-20.6v-20.6h10.6v-10.6h10.1v-10.1h10.6v-10.6h10.1v-10.1h20.6v-20.6h-10.6v-10.1h-10.1v-20.6h-10.1v-20.6h-10.6v-20.6h-10.1v10.6h-10.6v-10.6h-10.1v-10.1h10.1v-10.6h-20.6v-30.7h20.6v-10.1h10.6v10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h-10.1v-10.6h10.1v-10.1h10.6v10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h-10.1v-10.1h10.1v-10.6h10.1v10.6h10.6v10.1h-10.6v10.1h10.6v10.6h-10.6v10.1h10.6v-10.1h10.1v10.1h10.6v-10.1h-10.6v-10.6h10.6v-10.1h-10.6v-10.1h10.6v-10.6h10.1v10.6h10.6v-10.6h-10.6v-10.1h10.6v-10.6h-10.6v-10.1h10.6v-10.6h10.1v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h10.6v10.1h10.1v10.6h-10.1v10.1h10.1v10.1h-10.1v10.6h10.1v-10.6h10.6v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h10.6v10.1h10.1v-10.1h-10.1v-10.6h10.1v-10.1h-10.1v-10.6h10.1v-10.1h10.1v10.1h10.6v-10.1h-10.6v-10.1h10.6v-10.6h-10.6v-10.1h10.6v-10.6h10.1v10.6h10.6v10.1h-10.6v10.6h10.6v10.1h-10.6v10.1h10.6v-10.1h10.1v10.1h10.6v-10.1h-10.6v-10.1h10.6v-10.6h-10.6v-10.1h10.6v-10.6h10.1v10.6h10.1v-10.6h-10.1l-.5.4ZM1376.6,761.7h-10.1v10.6h10.1v-10.6ZM1397.3,761.7h-10.1v10.6h10.1v-10.6ZM1376.6,782.3h-10.1v10.1h10.1v-10.1ZM1397.3,782.3h-10.1v10.1h10.1v-10.1ZM1438.5,782.3h-10.1v10.1h10.1v-10.1ZM1315.2,813.1v-10.1h-10.6v10.1h10.6v10.6h-10.6v10.1h10.6v-10.1h10.1v10.1h10.6v-10.1h-10.6v-10.6h10.6v-10.1h-10.6v10.1h-10.1ZM1356.5,803h-10.6v10.1h10.6v-10.1ZM1376.6,803h-10.1v10.1h10.1v-10.1ZM1397.3,803h-10.1v10.1h10.1v-10.1ZM1417.9,803h-10.1v10.1h10.1v-10.1ZM1438.5,803h-10.1v10.1h10.1v-10.1ZM1356.5,823.6h-10.6v10.1h10.6v-10.1ZM1376.6,823.6h-10.1v10.1h10.1v-10.1ZM1417.9,823.6h-10.1v10.1h10.1v-10.1ZM1294.5,844.3h-10.1v10.1h10.1v-10.1ZM1315.2,844.3h-10.6v10.1h10.6v-10.1ZM1335.8,844.3h-10.6v10.1h10.6v-10.1ZM1356.5,844.3h-10.6v10.1h10.6v-10.1ZM1376.6,844.3h-10.1v10.1h10.1v-10.1ZM1417.9,844.3h-10.1v10.1h10.1v-10.1ZM1294.5,864.4h-10.1v10.6h10.1v-10.6ZM1315.2,864.4h-10.6v10.6h10.6v-10.6ZM1356.5,864.4h-10.6v10.6h10.6v-10.6ZM1232.6,895.6v-10.6h-10.1v10.6h10.1v10.1h-10.1v10.6h10.1v-10.6h10.6v10.6h10.1v-10.6h-10.1v-10.1h10.1v-10.6h-10.1v10.6h-10.6ZM1273.9,885.1h-10.1v10.6h10.1v-10.6ZM1294.5,885.1h-10.1v10.6h10.1v-10.6ZM1315.2,885.1h-10.6v10.6h10.6v-10.6ZM1335.8,885.1h-10.6v10.6h10.6v-10.6ZM1356.5,885.1h-10.6v10.6h10.6v-10.6ZM1397.3,885.1h-10.1v10.6h10.1v-10.6ZM1273.9,905.7h-10.1v10.6h10.1v-10.6ZM1294.5,905.7h-10.1v10.6h10.1v-10.6ZM1335.8,905.7h-10.6v10.6h10.6v-10.6ZM1212.5,926.3h-10.6v10.1h10.6v-10.1ZM1232.6,926.3h-10.1v10.1h10.1v-10.1ZM1253.3,926.3h-10.1v10.1h10.1v-10.1ZM1294.5,926.3h-10.1v10.1h10.1v-10.1ZM1335.8,926.3h-10.6v10.1h10.6v-10.1ZM1232.6,947h-10.1v10.1h10.1v-10.1ZM1273.9,947h-10.1v10.1h10.1v-10.1ZM1150.5,967.6h-10.1v10.1h10.1v-10.1ZM1171.2,967.6h-10.6v10.1h10.6v-10.1ZM1191.8,967.6h-10.6v10.1h10.6v-10.1ZM1212.5,967.6h-10.6v10.1h10.6v-10.1ZM1232.6,967.6h-10.1v10.1h10.1v-10.1ZM1273.9,967.6h-10.1v10.1h10.1v-10.1ZM1315.2,967.6h-10.6v10.1h10.6v-10.1ZM1150.5,988.3h-10.1v10.1h10.1v-10.1ZM1171.2,988.3h-10.6v10.1h10.6v-10.1ZM1212.5,988.3h-10.6v10.1h10.6v-10.1ZM1253.3,988.3h-10.1v10.1h10.1v-10.1ZM1109.3,1008.4h-10.1v10.6h10.1v-10.6ZM1129.9,1008.4h-10.1v10.6h10.1v-10.6ZM1150.5,1008.4h-10.1v10.6h10.1v-10.6ZM1171.2,1008.4h-10.6v10.6h10.6v-10.6ZM1212.5,1008.4h-10.6v10.6h10.6v-10.6ZM1253.3,1008.4h-10.1v10.6h10.1v-10.6ZM1150.5,1029.1h-10.1v10.6h10.1v-10.6ZM1191.8,1029.1h-10.6v10.6h10.6v-10.6ZM1150.5,1049.7h-10.1v10.6h10.1v-10.6ZM1191.8,1049.7h-10.6v10.6h10.6v-10.6ZM1232.6,1049.7h-10.1v10.6h10.1v-10.6ZM1171.2,1070.3h-10.6v10.1h10.6v-10.1ZM1171.2,1091h-10.6v10.1h10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1263.8,741.1v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1150.5,895.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1284.5,741.1v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1129.9,895.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.2,895.6h10.1v10.1h-10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1088.6,875v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1253.3,751.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1109.3,875v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1232.6,751.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1129.9,875v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,751.6h10.6v10.1h-10.6v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1150.5,875v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.8,751.6v10.1h-10.6v-10.1h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1304.6,741.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.2,885.1v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1140.5,885.1v10.6h-10.6v-10.6h10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1088.6,895.6v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1160.6,885.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1068.5,905.7h-10.6v-10.1h10.6v10.1h10.1v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1345.9,741.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1201.9,885.1v10.6h-10.1v-10.6h10.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1160.6,
    y: 669.1,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1201.9,
    y: 669.1,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1160.6,
    y: 689.7,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1201.9,
    y: 689.7,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1057.9,
    y: 833.7,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1037.3,
    y: 833.7,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1057.9,
    y: 813.1,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1057.9,
    y: 792.4,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1016.6,
    y: 792.4,
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1181.3,
    y: 710.3,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1201.9,
    y: 710.3,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1129.9,782.3h-10.1v-10.1h10.1v10.1h10.6v-10.1h10.1v10.1h-10.1v10.1h10.1v10.6h-10.1v-10.6h-10.6v10.6h-10.1v-10.6h10.1v-10.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1078.5,
    y: 792.4,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1099.2,
    y: 792.4,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 996.5,
    y: 833.7,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1078.5,
    y: 833.7,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1160.6,
    y: 710.3,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1160.6,
    y: 751.6,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1027.2,905.7h-10.6v-10.1h10.6v10.1h10.1v-10.1h10.6v10.1h-10.6v10.6h-10.1v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1047.8,864.4h-10.6v-10.1h10.6v10.1h10.1v-10.1h10.6v10.1h-10.6v10.6h10.6v10.1h-10.6v-10.1h-10.1v10.1h-10.6v-10.1h10.6v-10.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1222.5,
    y: 689.7,
    width: 10.1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1016.6,
    y: 875,
    width: 10.6,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 996.5,
    y: 875,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 975.8,
    y: 875,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1078.5,
    y: 751.6,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1119.8,
    y: 751.6,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1140.5,
    y: 751.6,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 996.5,
    y: 854.3,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 996.5,
    y: 895.6,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1140.5,
    y: 731,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1099.2,
    y: 710.3,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1140.5,
    y: 710.3,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1222.5,
    y: 710.3,
    width: 10.1,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1078.5,
    y: 772.3,
    width: 10.1,
    height: 10.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1061.1 552.6 1049.7 564 1046.1 564 1043.1 566.9 1043.1 572.5 1050.5 572.5 1050.5 582.8 1038.7 582.8 1030.9 590.6 1042.5 602.3 1051.2 602.3 1055.7 606.8 1055.7 613.6 1052.5 616.7 1056.7 616.7 1063.9 623.9 1058.9 629 1058.9 633.7 1054.3 638.2 1054.3 654.1 1071.2 671 1078.3 671 1085.4 663.9 1091.1 663.9 1094.7 660.2 1110.1 660.2 1096.9 647.1 1096.9 635.4 1092.4 635.4 1092.4 630.7 1086.2 624.5 1080.4 624.5 1080.4 618.9 1088 611.3 1088 606.8 1094.5 606.8 1099 602.4 1099 596.3 1098.5 596.5 1098.5 586.1 1092 586.1 1084.1 578.3 1080.4 581.9 1076.3 586.1 1073.7 586.1 1073.7 576.6 1073.7 570.1 1065.7 562 1065.7 557.2 1061.1 552.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1057.2,607.4h-10.3v-10.3h10.3v10.3h10.1v10.3h10.3v-10.3h10.3v-10.3h10.3v10.3h-10.3v10.3h10.3v31h10.3v10.1h10.3v10.3h-31v10.3h-20.6v-10.3h-10.1v-10.3h-10.3v-20.4h10.3v-31h0ZM1077.6,628h-10.3v10.3h10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1067.3,607.4v-10.3h10.3v10.3h-10.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1098.2 576.7 1098.2 586.7 1087.9 586.8 1087.9 576.7 1098.2 576.7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M810.9,833.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M831.3,833.7v-10.3h10.3v10.3h-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M831.3,833.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M810.9,833.7v-10.3h10.1v10.3h-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M841.7,833.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M790.3,895.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M780,844v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M790.3,833.7v-10.3h10.3v10.3h-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M800.6,844v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M780,833.7h-10.3v-10.3h10.3v10.3h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M821,844v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M780,885.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M841.7,844v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M790.3,874.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M852,844h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M872.6,854.3v-10.3h20.4v10.3h-20.4v10.3h30.7v10.1h-10.3v10.3h10.3v-10.3h10.3v10.3h10.3v10.3h-10.3v51.4h10.3v20.6h-10.3v31h-30.7v-10.3h-10.3v-10.3h-10.3v-10.3h-31v-10.3h-10.3v-10.3h-10.1v-10.1h-10.3v-20.6h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.3v10.3h10.1v-10.3h-10.1v-10.1h10.1v-10.3h10.3v10.3h10.3v10.1h-10.3v10.3h10.3v-10.3h10.3v10.3h10.3v-10.3h-10.3v-10.1h10.3v-10.3h10.3v-.2ZM821,895.4h-10.1v10.3h10.1v-10.3ZM841.7,895.4h-10.3v10.3h10.3v-10.3ZM862.3,895.4h-10.3v10.3h10.3v-10.3ZM903.3,895.4h-10.3v10.3h10.3v-10.3ZM841.7,916h-10.3v10.3h10.3v-10.3ZM841.7,936.7h-10.3v10.1h10.3v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M790.3,854.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M800.6,864.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M810.9,854.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M780,864.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M852,854.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 790.3,
    y: 782.3,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 831.3,
    y: 782.3,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 728.6,
    y: 802.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 769.7,
    y: 802.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 790.3,
    y: 802.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 831.3,
    y: 802.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 852,
    y: 741.1,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 749,
    y: 844,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 831.3,
    y: 761.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 852,
    y: 761.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 790.3,
    y: 761.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 810.9,
    y: 802.7,
    width: 10.1,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 810.9,
    y: 782.3,
    width: 10.1,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 903.3,
    y: 916,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M996,936.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M975.3,936.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M954.7,947h-10.3v-10.3h10.3v10.3h10.3v10.1h-10.3v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1047.3,936.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,947v-10.3h10.3v10.3h-10.3v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M903.3,936.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M985.7,947v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1047.3,926.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,957.1h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M954.7,957.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1026.7,926.3v10.3h10.3v10.3h-10.3v10.1h10.3v-10.1h10.3v10.1h41v20.6h20.6v31h-10.3v10.3h-20.4v-10.3h-51.6v10.3h10.3v10.1h-10.3v31h-10.3v-10.3h-10.1v20.6h-20.6v-10.3h-10.3v-10.3h-10.3v20.6h-30.7v-20.6h-10.3v-10.3h10.3v-10.3h-10.3v-10.1h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.1v10.3h10.3v10.3h-10.3v10.3h10.3v-10.3h10.3v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.3v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.1h10.3v10.1h10.1v-10.1h-10.1v-10.3h10.1v-10.3h10.3v-.2ZM1016.4,967.4h-10.1v10.3h10.1v-10.3ZM1037,967.4h-10.3v10.3h10.3v-10.3ZM1057.7,967.4h-10.3v10.3h10.3v-10.3ZM1016.4,988h-10.1v10.3h10.1v-10.3ZM1037,988h-10.3v10.3h10.3v-10.3ZM996,1008.7h-10.3v10.3h10.3v-10.3ZM954.7,1029.1h-10.3v10.3h10.3v-10.3ZM975.3,1029.1h-10.3v10.3h10.3v-10.3ZM954.7,1049.7h-10.3v10.3h10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M975.3,957.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1006.3,926.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,967.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M965,967.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M985.7,926.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M985.7,967.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1047.3,916h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,1029.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M975.3,905.7h-10.3v-10.3h10.3v10.3h10.3v-10.3h10.3v10.3h-10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,1008.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M913.7,977.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1037,916v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,977.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M954.7,977.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1016.4,916v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M975.3,977.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M985.7,916h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M924,988v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M975.3,916v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1016.4,905.7h-10.1v-10.3h10.1v10.3h10.3v10.3h-10.3v-10.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M965,988v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1037,916v-10.3h10.3v10.3h-10.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 944.4,
    y: 916,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 965,
    y: 875,
    width: 10.3,
    height: 10.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "1077.3 1008.3 1058.7 1008.3 1055.8 1011.1 1034.5 1011.1 1034.5 1020 1023.9 1030.7 1023.8 1044.4 1021.8 1055.5 1027.6 1061.3 1032.4 1061.3 1032.4 1069.8 1042.3 1079.8 1048.6 1079.8 1054.1 1085.2 1054.1 1088.4 1064.7 1088.4 1073.1 1096.7 1078 1096.7 1085.6 1104.3 1096.2 1104.3 1107.9 1116 1107.9 1122.1 1099.5 1130.4 1099.5 1138.9 1093.4 1145 1093.4 1146.4 1116.7 1146.4 1122.4 1152.1 1129.2 1152.1 1153.9 1127.4 1153.9 1088 1151.3 1085.4 1144.1 1092.6 1138.2 1086.7 1138.2 1064 1129.1 1054.8 1121.1 1062.8 1097 1062.8 1097 1027.9 1077.3 1008.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1082.4,1041.5v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1072.8,1041.5v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1039.2,1046.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1063.2,1041.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1053.6,1041.5v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,1046.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1087.2,1046.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1020,1051.1h4.8v4.8h-4.8v-4.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,1007.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1039.2,1051.1h4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1053.6,1051.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1096.8,1036.7v4.8h4.8v4.8h-4.8v4.8h4.8v4.8h-4.8v4.8h24v-4.8h4.8c0,.4-.2,4.8,0,4.8h4.8v-4.8h4.8v4.8h4.8v14.4h-4.8v4.8h4.8v4.8h-4.8v4.8h4.8v-4.8h14.4v48h-4.8v4.8h-4.8v4.8h-4.8v4.8h-4.8v4.8h-4.8v4.8h-9.6v-4.8h-4.8v-4.8h-24v-9.6h4.8v-9.6h4.8v-4.8h4.8v-4.8h-4.8v-4.8h-4.8v-4.8h-4.8v-4.8h-4.8v4.8h-4.8v-4.8h-4.8v-4.8c.4,0,4.8.2,4.8,0v-4.8h-4.8c-.2,0,0,4.4,0,4.8h-4.8v-4.8h-4.8v-4.8h4.8v-4.8h-4.8v-4.8h4.8v-4.8h4.8v4.8h4.8v-4.8h-4.8v-4.8h4.8v-4.8h-4.8v-4.8h4.8v-4.8h4.8v4.8h4.8v-4.8h-4.8v-4.8h4.8v-4.8h-4.8v-4.8h4.8v-4.8h4.8ZM1092,1070.3v-4.8h-4.8v4.8h4.8v4.8h-4.8v4.8h4.8v-4.8h4.8v4.8h4.8v-4.8h-4.8v-4.8h4.8v-4.8h-4.8v4.8h-4.8ZM1111.2,1065.5h-4.8v4.8h4.8v-4.8ZM1120.8,1065.5h-4.8v4.8h4.8v-4.8ZM1130.4,1065.5h-4.8v4.8h4.8v-4.8ZM1111.2,1075.1h-4.8v4.8h4.8v-4.8ZM1120.8,1075.1h-4.8v4.8h4.8v-4.8ZM1082.4,1084.7h-4.8v4.8h4.8v-4.8ZM1092,1084.7h-4.8v4.8h4.8v-4.8ZM1101.6,1084.7h-4.8v4.8h4.8v-4.8ZM1120.8,1084.7h-4.8v4.8h4.8v-4.8ZM1092,1094.3h-4.8v4.8h4.8v-4.8ZM1111.2,1094.3h-4.8v4.8h4.8v-4.8ZM1111.2,1103.9h-4.8v4.8h4.8v-4.8ZM1130.4,1103.9h-4.8v4.8h4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1063.2,1051.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1087.2,1036.7v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1072.8,1051.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,1036.7v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1082.4,1051.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1125.6,1055.9v-4.8h4.8v4.8h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1096.8,1031.9h4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1029.6,1055.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1092,1031.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1039.2,1055.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1082.4,1031.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1072.8,1036.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1068,1031.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1058.4,1055.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1068,1055.9v4.8h4.8v4.8h-4.8v4.8h-4.8v-4.8h-4.8v-4.8h4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,1055.9v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1092,1027.1h4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1034.4,1060.7v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1087.2,1027.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1053.6,1060.7v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1068,1027.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1087.2,1022.3h4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1048.8,1065.5v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1082.4,1022.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,1065.5v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1068,1084.7v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1058.4,1075.1v4.8h4.8v4.8h-4.8v4.8h-4.8v-4.8h-4.8v-4.8h4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1034.4,1075.1h-4.8v-4.8h4.8v4.8h4.8v-4.8h4.8v4.8h-4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1048.8,1075.1v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1053.6,1070.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,1012.7h4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1063.2,1070.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1082.4,1017.5h4.8v4.8h-4.8v-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1072.8,1070.3v4.8h-4.8v-4.8h4.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 1020,
    y: 1041.5,
    width: 4.8,
    height: 4.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1109,1276h10.3v10.3h10.3v10.3h-10.3v10.1h10.3v10.3h-10.3v10.3h10.3v-10.3h10.3v10.3h10.3v10.3h-10.3v10.3h-10.3v-10.3h-10.3v10.3h10.3v10.3h-31v10.3h-10.1v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v10.3h-10.3v-10.3h-10.3v10.3h10.3v10.3h-10.3v10.3h10.3v10.1h-10.3v10.3h10.3v10.3h-10.3v20.6h-10.3v10.3h10.3v20.4h-20.6v10.3h-10.3v10.3h10.3v31h-30.7v20.4h10.3v10.3h20.4v41.3h-10.3v30.7h-20.4v31h10.3v20.6h-20.6v-10.3h-20.6v10.3h-20.6v-20.6h-10.1v-10.3h-20.6v-41h10.3v-92.6h-10.3v-31h-10.3v-10.3h10.3v-10.1h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-30.7h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.3v10.3h10.3v10.3h-10.3v10.3h10.3v10.3h-10.3v10.3h10.3v-10.3h10.1v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.3v10.3h10.3v10.3h-10.3v10.3h10.3v10.3h-10.3v10.3h10.3v-10.3h10.3v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.3v10.3h10.1v10.3h-10.1v10.3h10.1v10.3h-10.1v10.3h10.1v-10.3h10.3v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h10.3v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.1h10.3v10.1h10.3v10.3h-10.3v10.3h10.3v-10.3h10.1v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.1h-10.3v-10.3h10.3v-10.3h0ZM1109,1337.7h-10.3v10.3h10.3v-10.3ZM944.6,1378.7h-10.3v10.3h10.3v-10.3ZM965,1378.7h-10.3v10.3h10.3v-10.3ZM985.7,1378.7h-10.3v10.3h10.3v-10.3ZM1006.3,1378.7h-10.3v10.3h10.3v-10.3ZM1026.7,1378.7h-10.1v10.3h10.1v-10.3ZM1047.3,1378.7h-10.3v10.3h10.3v-10.3ZM944.6,1399.4h-10.3v10.3h10.3v-10.3ZM985.7,1399.4h-10.3v10.3h10.3v-10.3ZM1026.7,1409.7v-10.3h-10.1v10.3h10.1v10.3h-10.1v10.3h20.4v-20.6h-10.3ZM944.6,1420h-10.3v10.3h10.3v-10.3ZM965,1420h-10.3v10.3h10.3v-10.3ZM985.7,1420h-10.3v10.3h10.3v-10.3ZM965,1440.7h-10.3v10.1h10.3v-10.1ZM1006.3,1440.7h-10.3v10.1h10.3v-10.1ZM965,1461.1h-10.3v10.3h10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1078.3,1358.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M944.6,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1098.7,1276v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M954.7,1286.3h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M985.7,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1078.3,1276v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1006.3,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1057.7,1276v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1026.7,1286.3v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1037,1276v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1047.3,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1016.6,1276v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1068,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1098.7,1265.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1088.6,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1088.6,1265.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M954.7,1296.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1057.7,1265.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M975.3,1296.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1047.3,1265.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M996,1296.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1016.6,1265.7h10.1v10.3h-10.1v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1016.6,1296.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1006.3,1265.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1037,1296.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M985.7,1276h-10.3v-10.3h10.3v10.3h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1057.7,1296.7v10.1h-10.3v-10.1h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M944.6,1276h-10.3v-10.3h10.3v10.3h10.1v-10.3h10.3v10.3h-10.3v10.3h-10.1v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1098.7,1255.4v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1098.7,1296.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1057.7,1255.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1016.6,1255.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1129.7,1296.7h10.3v10.1h-10.3v-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M944.6,1306.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1098.7,1245.1h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M965,1306.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1088.6,1245.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M985.7,1306.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1057.7,1245.1h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1006.3,1306.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1047.3,1245.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1026.7,1306.7v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1016.6,1245.1h10.1v10.3h-10.1v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1047.3,1306.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1006.3,1245.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1037,1337.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M996,1337.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1140,1306.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1088.6,1234.7h-10.3v-10.1h10.3v10.1h10.1v-10.1h10.3v10.1h-10.3v10.3h-10.1v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M954.7,1317.1v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1047.3,1234.7h-10.3v-10.1h10.3v10.1h10.3v-10.1h10.3v10.1h-10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1006.3,1234.7h-10.3v-10.1h10.3v10.1h10.3v-10.1h10.1v10.1h-10.1v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M996,1317.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M954.7,1337.7v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1037,1317.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1016.6 1718.3 1016.6 1677.1 1037 1677.1 1037 1687.4 1047.3 1687.4 1047.3 1697.7 1078.3 1697.7 1078.3 1718.3 1016.6 1718.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 913.7,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 913.7,
    y: 1245.1,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 913.7,
    y: 1286.3,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 913.7,
    y: 1224.7,
    width: 10.3,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1057.7,
    y: 1183.4,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1098.7,
    y: 1183.4,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 954.7,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 996,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1037,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1057.7,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1078.3,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1098.7,
    y: 1204,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M965,1234.7h-10.3v-10.1h10.3v10.1h10.3v-10.1h10.3v10.1h-10.3v10.3h10.3v10.3h-10.3v-10.3h-10.3v10.3h-10.3v-10.3h10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 934.3,
    y: 1245.1,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1057.7,
    y: 1162.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1119.3,
    y: 1162.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1098.7,
    y: 1162.7,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1016.6,
    y: 1162.7,
    width: 10.1,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1016.6,
    y: 1183.4,
    width: 10.1,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1016.6,
    y: 1204,
    width: 10.1,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1024 1707.1 1012 1659.3 1007.6 1663.7 1003.1 1659.2 1000.7 1661.5 1000.7 1666.4 997.2 1669.8 992.5 1669.8 991.5 1670.9 994.4 1673.8 991.8 1676.4 991.8 1682.2 995.7 1686.1 1003.1 1678.8 1009.1 1678.8 1009.1 1685.2 999.9 1694.4 1005.4 1699.9 1011.9 1699.9 1017.6 1705.5 1024 1707.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1023.4 1710.3 1023.4 1715.1 1021.2 1717.4 1009.3 1714.7 999.3 1718.7 1002.5 1721.9 1001.2 1723.2 996.9 1723.2 993.8 1723.2 997.5 1719.5 993.4 1715.4 992.1 1715.4 985.9 1709.2 992.4 1709.2 992.4 1706.7 995.9 1706.7 995.9 1710.5 1001 1710.5 1005.8 1705.7 1003.2 1703.1 1007 1703.1 1023.4 1710.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1012.6 1720.5 1020.4 1720.5 1032.3 1717.2 1048.8 1717.2 1048.8 1721.8 1046.6 1724 1043.9 1721.2 1040.6 1724.4 1036.9 1724.4 1033.3 1720.8 1030.7 1720.8 1029.5 1722 1023.1 1722 1026.7 1725.6 1031 1725.6 1031 1727.8 1037.6 1734.5 1035.1 1734.5 1030.4 1729.7 1028.2 1731.9 1023.8 1727.5 1020.8 1727.5 1020.8 1728.9 1022.7 1730.9 1021.1 1732.4 1018.8 1730.1 1016.9 1732.1 1013.9 1729.2 1013.9 1727.6 1013.9 1725.8 1010.6 1729.1 1008.4 1726.9 1014.2 1723.6 1016.6 1723.6 1012.6 1720.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "992.6 1685.7 991.6 1685.2 991.3 1687.5 989.7 1690.4 991.6 1693.3 990.5 1695.2 990.5 1697.1 996.7 1700 997.3 1699.5 994.2 1696.4 995.8 1694.8 992.6 1685.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "988.4 1700.7 986.7 1702.4 988.8 1704.5 986.5 1706.8 984.6 1704.9 983.1 1703.4 981.9 1704.7 980.1 1702.9 976.8 1702.9 975.9 1703.8 972.5 1700.4 977.2 1700.4 978.9 1698.7 983.2 1698.7 985 1700.8 988.4 1700.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "948.1 1688.7 944.8 1688.7 944.8 1691.3 949.2 1695.7 952.3 1695.7 956 1699.5 961.5 1699.5 964.3 1702.3 965.9 1703.9 969 1700.7 965.8 1697.5 970.1 1697.5 970.1 1695.3 967.2 1695.3 964.3 1695.3 964.3 1693.6 959 1688.2 954.4 1688.2 951.1 1691.5 948.1 1688.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "927 1674.6 932.2 1679.8 936.9 1684.6 941.9 1684.6 943.1 1683.4 945.9 1686.2 952.9 1686.2 953.5 1685.6 954.5 1684.6 949.3 1684.6 947 1682.3 941.8 1682.3 937.1 1677.7 933.3 1677.7 928.1 1672.5 927 1674.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "902.7 1575.8 907.9 1575.8 907.9 1571.4 898.4 1562 895.1 1562 902.1 1569 902.7 1575.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "890.3 1570.1 893.4 1570.1 896.3 1572.9 896.3 1579.2 900.1 1579.2 900.1 1575.2 898 1573.1 894 1569 894 1564.2 890.3 1564.2 890.3 1570.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "893.2 1573.9 890.8 1573.9 890.8 1576.4 893.1 1578.7 894.6 1577.1 893.2 1573.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "895.3 1581.6 893.9 1582.9 895.9 1584.9 895.9 1590 899.2 1586.7 899.2 1583.7 895.3 1581.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "901.3 1580.7 901.3 1583.8 903.4 1585.9 901 1588.2 902.7 1589.8 904.7 1587.9 905.5 1588.7 905.5 1591.1 902.9 1593.7 899.7 1593.7 903 1599.7 903 1602.6 906.2 1605.2 907.1 1604.5 907.9 1601 909.3 1601.3 909.3 1607.5 910.8 1609.1 913.2 1606.8 913.2 1601.9 913.2 1597.9 912.1 1596.9 912.1 1591.1 909.1 1588.1 909.1 1580.8 907.3 1579 903.2 1579 901.3 1580.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "899.1 1598.2 897.2 1600 898.2 1600.9 896.9 1602.2 898.5 1603.8 899.7 1602.6 901.2 1601.2 899.1 1598.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "909.5 1611.4 905.1 1611.4 905.1 1612.7 903.6 1614.3 905.4 1616.2 905.4 1617.8 908.9 1617.8 908.9 1614.3 909.5 1611.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "913.3 1619.2 916.3 1622.2 918.4 1622.2 921.7 1625.6 921.7 1623.8 918.1 1620.2 916.4 1620.2 913.9 1617.7 913.3 1619.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "913.2 1625.2 913.2 1628.7 917 1632.4 919.4 1632.4 920.5 1631.4 916.6 1627.5 913.2 1625.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "913.2 1632.9 911.8 1632.9 914.1 1635.2 909.5 1639.7 911 1641.2 918.5 1641.2 918.5 1638.8 921 1638.8 921 1637.7 917.8 1634.5 916 1634.5 913.2 1632.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "918.2 1645.7 916.9 1645.7 918.3 1647.2 915.7 1649.8 915.7 1652.1 917.7 1654.2 919.2 1652.7 917.9 1651.4 920.1 1649.2 920.1 1647 920.1 1645.7 918.2 1645.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "923 1647.1 921.1 1649 924.1 1651.9 925.2 1650.8 923 1647.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "928.3 1644.5 928.3 1648.8 929.9 1650.4 933.5 1652 933.5 1650.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "930.7 1657.5 930 1658.3 934.8 1663.1 934.8 1660.8 930.7 1657.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "937.9 1665.9 934.4 1665.9 934.4 1668.5 936.7 1670.8 938.7 1668.8 937.9 1665.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "886.6 1432.9 886.6 1435.7 887.9 1437 887.9 1439.6 885.6 1441.9 885.6 1443.9 887.3 1445.6 887.3 1459.1 884.3 1462.1 887.9 1462.1 890.1 1464.3 894.7 1464.3 894.7 1459.5 897.1 1457.1 898.7 1457.1 892.9 1451.3 892.9 1446.8 896.2 1446.8 896.2 1441.6 896.2 1436.1 893.5 1433.3 891.5 1431.4 888.3 1431.4 886.6 1432.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "911.1 1484.4 907.7 1486.1 905.7 1490.4 907 1495.2 913 1494.1 915.9 1490.1 911.1 1484.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "902.5 1501.2 898.5 1501.2 898.5 1507.3 902.5 1507.3 903.8 1505.9 902.5 1501.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1008.1,1651h-3.3l-2.2-2.2h-27.6l-3.9,3.9-3.3-3.3h-10.8v-7.5l-1.8-1.8v-3l-4-4v-13.5h-2.8l-6.4,6.4h-4.2l-9.4-9.4v-9.2l2.5-2.5v-13.8l11-11v-8.2l-3.3-3.3v-18.5l4.8-4.9-4.6-4.6v-4.8l4.3-4.3-4.9-4.9v-16.3l4.4-4.4v-4.3l-7.7-7.7h-2.8l-2.6,2.6-5.5-5.5,3.3-3.3h7.8l2.4-2.4v-2.9l-.5-.5-1.1,1.1h-4.8v-10.7l-5.5-5.5v-8.7l-7.1-7.1v-12.5l2.9-2.9v-3.8l-3.4-3.4v-30.3l-4.6-4.6v-6.9l7.8-7.8v-7.9l4.9-4.9-2.2-2.2v-4.5l-6.5-6.5v-29.3l9-9v-4.6l-9.4-9.4,4.8-4.8v-4l-3.9-3.9,7.2-7.2h2.6v-17l-2.6-2.6v-10.2l-8.5-8.5v-5.1l-3.5-3.5v-17.6h4.9v-6.6l4.2-4.2v-7.8l-5.2-5.2v-8.4l2.7-2.7v-12.5l4.6-4.6v-6.1l12.3-12.3-.6-.6v-5.1l-2.7-2.7v-4.4l2.3-2.3v-3.1l-5.4-5.4c-2.4-2.4-.5-6.2-.3-6.6v-.2c0,0,2.5-2.4,2.5-2.4v-1.6l-3.6-3,1.7-5.7,18.2-9.7,3.4-15.2v-4.8h-.7l-1.6,1.6h-5.7l-11.8-32.3-13.2-13.2,6.5-6.5-3.4-3.4,2.9-2.9v-1.2l-11.1-11.1v-12.8l-4.5-4.5v-2.7l-2.4,2.4,3,3-6.4,6.4-1.7-1.7-5.8,6.1-.7-.7v257.2l10.9,10.9-11.5,11.5-10.4,61.3-6.7-1.4v13.9l14.8,14.8v26.2l-5.9,5.9v17.1l19.7,19.7v40.4l14.3,14.3-9.1,9.1v33.7h-6.4v-11.4h-4.9v-7.7h-13.8v9l-8.5,8.5,7.1,7.1,6.8-6.8,3.2,3.2h7.6v13.2l7.8,7.8h9.5l-3.4,3.4h-10v5.9l4.1,4.1h5.2l-3.2,3.2v5.4h-2.2v6l4.6,4.6v4.6l2.9,2.9v-10.1l2.9-2.9,2.7,2.7-1.5,1.5v8.3h2.4l-6.4,6.4v13.5l7.4,7.4,4.3,4.3h-3.6v4.3l4.8,4.8h3.6v5.4h-3.9v2.2l8.7,8.7h2v-7.8l3.5,3.5,2-2v-2.2l-2.6-2.6-2.3-2.3h10.2l4.3,4.3v3.6l-2.3,2.3v1.9l3.1,3.1-5.2,5.2v-9.8l-3.3,3.3v5l-3.7-3.7-5.1,5.1v7.5h5.3l2.7,2.7-4,4h3.6l3.7,3.7,2.6-2.6v-5.5l-3.2-3.2,3.4-3.4h19.8v2.5l-3.2,3.2-3.2-3.2-6.8,6.8h-3.4l-1.9,1.9.8.8-2.5,2.5,1,1,1.2,1.2-1.7,1.7v1h2.7l1.8,1.8,3,3,1.3-1.3v-2.2l2.3-2.3,1.3-1.3-2.7-2.7.9-.9h4.1l3-3v-.9l4.3-4.3.7.7,1.5,1.5h2.8v1.4h-2.3v1.6l-1.5,1.5v2.1l-2.7,2.7v2.9l1.8,1.8-4.8,4.8-1.1-1.1v-2.2l1-1v-3.8l-1.2,1.2v2.2h-4.1l-.6.6,2,2v1.2l4.3,4.3h4.2l3,3h2.9l.8.8,4.3-4.3-4.2-4.2,3-3v-17.9l3.4-3.4,3.8-3.8h5.5l1.1-1.1v-4.5l2-2h5.1l2,2,1.1-1.1-2.1-2.5.2-.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M903.3,1204h-10.3v-10.3h10.3v10.3h10.1v-10.3h10.3v10.3h-10.3v10.3h-10.1v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M903.3,1214.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M923.7,1306.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1214.3h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1224.7v10.1h-10.1v-10.1h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M903.3,1234.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M893,1389.1v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1234.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1245.1v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1368.7v10.1h10.3v10.3h-10.3v10.3h10.3v10.3h-10.3v10.3h10.3v10.3h-10.3v10.3h10.3v10.1h-10.3v10.3h10.3v-10.3h10.3v31h10.3v10.3h-10.3v10.3h10.3v10.3h-10.3v10.1h10.3v51.6h-10.3v10.3h10.3v10.1h-10.3v20.6h20.6v31h61.7v41h10.3v20.6h31v20.6h-10.3v10.3h-41.3v-10.3h-20.6v-20.6h-41v-31h-10.3v10.3h-10.3v-30.7h-10.3v-10.3h10.3v-10.3h-10.3v10.3h-10.1v-51.6h-10.3v-10.1h10.3v-10.3h-10.3v10.3h-10.3v-20.6h10.3v-20.6h-10.3v-10.3h-10.3v-10.3h10.3v-10.1h10.3v10.1h10.3v-10.1h-10.3v-10.3h10.3v-31h-20.6v-61.7h10.3v10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.3h10.3v-10.1h10.1,0ZM903.3,1430.3h-10.3v10.3h10.3v-10.3ZM903.3,1450.7h-10.3v10.3h10.3v-10.3ZM923.7,1471.4h-10.3v10.3h10.3v-10.3ZM923.7,1512.7h-10.3v10.1h10.3v-10.1ZM923.7,1533.1h-10.3v10.3h10.3v-10.3ZM923.7,1553.7h-10.3v10.3h10.3v-10.3ZM923.7,1615.4h-10.3v10.3h10.3v-10.3ZM985.4,1677.1h-10.1v10.3h10.1v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M923.7,1245.1h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M903.3,1255.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1358.3h20.6v10.3h-20.6v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M923.7,1255.4v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1265.7v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1348v10.3h-10.1v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M923.7,1265.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M903.3,1276v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1337.7h10.3v10.3h-10.3v-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M923.7,1276v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M893,1286.3v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M893,1327.4v10.3h10.3v10.3h-10.3v10.3h10.3v10.3h-10.3v10.1h-10.3v-30.7h-10.3v-10.3h10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M913.4,1286.3v10.3h10.3v10.1h-10.3v10.3h10.3v10.3h-10.3v10.3h-10.1v-10.3h-10.3v-10.3h10.3v-10.3h-10.3v-10.1h10.3v-10.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M893,1306.7v10.3h-10.3v-10.3h10.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 913.4,
    y: 988,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 934.1,
    y: 1132,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 893,
    y: 1173.1,
    width: 10.3,
    height: 10.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M944.3,1323.6h-8.6l-1.9,6.8h-4.9l6.1-21.1h9.9l6.1,21.1h-4.9l-1.9-6.8h.1ZM943.2,1319.4l-2.5-9h-1.2l-2.5,9h6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.2,1309.3h8.2c5,0,9.4,1.2,9.4,5.9s-2.8,4.4-5.4,4.7v1.2h3.1c1.6,0,2.5.9,2.5,2.5v6.8h-4.8v-7.4h-8.3v7.4h-4.8v-21.1h0ZM961.4,1318.8c2.8,0,4.6,0,4.6-2.6s-1.8-2.7-4.6-2.7h-3.4v5.3h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.9,1309c5.3,0,9.4,3.2,10,7.9h-4.8c-.5-2.5-2.1-3.7-5.2-3.7s-5.8,2-5.8,6.7,1.7,6.7,5.2,6.7,4.7-1.4,4.7-4.3h-4.9v-3.6h11c1.7,0,2.6.9,2.6,2.5v9.2h-4.8v-7.3l.9-3.3h-1.2c0,6.6-2.6,10.9-8.5,10.9s-9.8-4.4-9.8-10.9,4.5-10.9,10.6-10.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999,1309.3h15.1v4.2h-10.3v4.3h8.8v4.2h-8.8v4.3h10.3v4.2h-15.1v-21.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.8,1309.3h9.4l6.4,19.9h1.2l-.9-3v-16.9h4.8v21.1h-9.5l-6.4-19.9h-1.2l.9,3v16.9h-4.8v-21.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.4,1313.5h-6.9v16.9h-4.8v-16.9h-6.9v-4.2h18.6v4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.4,1313.5v12.7h4.8v4.2h-14.4v-4.2h4.8v-12.7h-4.8v-4.2h14.4v4.2h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.9,1309.3h9.4l6.4,19.9h1.2l-.9-3v-16.9h4.8v21.1h-9.5l-6.4-19.9h-1.2l.9,3v16.9h-4.8v-21.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.3,1323.6h-8.6l-1.9,6.8h-4.9l6.1-21.1h9.9l6.1,21.1h-4.9l-1.9-6.8h.1ZM1115.1,1319.4l-2.5-9h-1.2l-2.5,9h6.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1009,1238.8v-.2h-34v-11.7h48.8v11.2c-12.3,12.5-23.7,32.4-24.7,57.3h-14.8c.9-25.2,14.3-45.9,24.7-56.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.4,1275.6h13.4c1.2,6.7,6.8,9.9,13.9,9.9s12.7-5.6,12.7-12.9-5.5-12.6-12.7-12.6-9.2,2-11.2,4.3h-13.1l6.6-37.4h40.4v11.3h-30.9l-2.6,14.8h.2c3-2.6,7.9-4.3,14.2-4.3,12.1,0,23.2,9.1,23.2,23.9s-11.5,24.3-26.5,24.3-26.3-8-27.6-21.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.6,312.7h11l3.6,23.3h1.4l3.6-23.3h11v24.7h-5.6v-19.8l1-3.5h-1.4l-4,23.3h-10.9l-4-23.3h-1.4l1,3.5v19.8h-5.6v-24.7h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.8,312.7h17.6v4.9h-12v5h10.3v4.9h-10.3v5h12v4.9h-17.6v-24.7h0ZM326.6,303.9l.9,4-13.7,3-.9-4,13.7-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,325.7v-1.4l-8.3-11.6h6.4l6.7,9.5,6.7-9.5h6.4l-8.4,11.6v1.4l8.4,11.7h-6.4l-6.7-9.5-6.7,9.5h-6.4l8.3-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,317.6v14.9h5.6v4.9h-16.8v-4.9h5.6v-14.9h-5.6v-4.9h16.8v4.9h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,312.3c6.9,0,11.4,3.8,12.2,9.9h-5.6c-.6-3.3-3.2-5-6.5-5s-7.1,2.7-7.1,7.8,2.8,7.8,7.1,7.8,6-1.8,6.5-5h5.6c-.7,6.1-5.3,9.9-12.2,9.9s-12.7-5.5-12.7-12.7,4.8-12.7,12.7-12.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,312.3c7.8,0,12.6,5.5,12.6,12.7s-4.8,12.7-12.6,12.7-12.6-5.5-12.6-12.7,4.8-12.7,12.6-12.7ZM417.6,332.8c4.7,0,7-3,7-7.8s-2.3-7.8-7-7.8-7,3-7,7.8,2.3,7.8,7,7.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317,261.7c-.1-12.1,2.3-21.9,8.4-28.8,4.4-5,10.4-7.9,19.7-7.9,13.7,0,21.9,7.5,23.6,17.7h-13.1c-1-4.2-4-7.3-10-7.3-10,0-14.8,7.5-14.8,19.6h.2c3.6-4.2,8.1-7.1,16.1-7.1,12.7,0,23.8,9.9,23.8,24.5s-11.2,24-25.5,24-28.2-16.1-28.4-34.7h0ZM357.9,272.6c0-7.8-5.5-13.7-12.9-13.7s-13.3,5.7-13.3,13.6,5.5,13.2,13.2,13.2,13-5.7,13-13.1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M986,806.4h8.7c6.9,0,10.2,1.2,10.2,6.1s-3.3,4.7-5.9,4.9v1.4c3.7,0,7.7.5,7.7,5.7s-5.1,6.5-11.6,6.5h-9.1v-24.7h0ZM995.4,815.7c2.3,0,3.9,0,3.9-2.2s-1.6-2.2-3.9-2.2h-3.8v4.5h3.8ZM995.8,826.1c3.3,0,5.3,0,5.3-2.7s-2-2.8-5.3-2.8h-4.2v5.5h4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.5,806.4h9.6c5.9,0,11,1.4,11,6.9s-3.3,5.2-6.3,5.5v1.4h3.6c1.9,0,3,1,3,3v7.9h-5.6v-8.7h-9.7v8.7h-5.6v-24.7h0ZM1019,817.5c3.3,0,5.4,0,5.4-3.1s-2.1-3.1-5.4-3.1h-4v6.2h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.7,823.1h-10l-2.2,7.9h-5.7l7.1-24.7h11.6l7.1,24.7h-5.7l-2.2-7.9h0ZM1049.3,818.2l-2.9-10.5h-1.4l-2.9,10.5h7.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.2,831.4c-8.9,0-12.2-3.6-12.2-9.9h5.6c0,3.8,1.9,5,6.8,5s4.8-.8,4.8-2.2-3-2.6-6.6-3.8c-5.2-1.8-9.5-3.2-9.5-8s3.3-6.5,9.7-6.5,11,3.9,11,8.8h-5.6c0-3-2.3-3.9-5.4-3.9s-4.1.6-4.1,1.8.6,1.5,4.5,2.9c4.6,1.5,11.5,3.5,11.5,8.6s-3,7.1-10.6,7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.7,811.3v14.9h5.6v4.9h-16.8v-4.9h5.6v-14.9h-5.6v-4.9h16.8v4.9h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.4,828.4v-22.1h5.6v20.1l12-.4v4.9l-14.6.4c-1.9,0-3-1-3-2.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1017.1,761.4c8.6-6.8,18-11.6,18-20.4s-3.4-10.7-9.5-10.7-11,5-11.2,13.9h-12.8c0-15.6,8-25.5,24.3-25.5s23.3,10.1,23.3,21.9-8.8,19-17.2,24.6c-5.3,3.4-11.5,7.8-13.8,12.2h31.6v11.2h-49.2c.5-13.1,8.7-21.1,16.5-27.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.2,773.7h-31.6v-14.7l31.1-39.7h13.8v43.5h10.4v10.9h-10.4v14.9h-13.3v-14.9ZM1061.6,762.8h20.6v-26.6h-.2l-20.4,26.3v.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M772.1,1197.4c6.9,0,11.4,3.8,12.2,9.9h-5.6c-.6-3.3-3.1-5-6.5-5s-7.1,2.7-7.1,7.8,2.8,7.8,7.1,7.8,6-1.8,6.5-5h5.6c-.7,6.1-5.3,9.9-12.2,9.9s-12.7-5.5-12.7-12.7,4.8-12.7,12.7-12.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811,1197.7v24.7h-5.6v-9.6h-12.4v9.6h-5.6v-24.7h5.6v10.2h12.4v-10.2h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.4,1202.6v14.9h5.6v4.9h-16.8v-4.9h5.6v-14.9h-5.6v-4.9h16.8v4.9h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.1,1219.8v-22.1h5.6v20.1l12-.4v4.9l-14.6.4c-1.9,0-3-1-3-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.5,1197.7h17.6v4.9h-12v5h10.3v4.9h-10.3v5h12v4.9h-17.6v-24.7h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M761.3,1162.3h13c.5,8.2,4.1,13.9,13.5,13.9s12.1-4.1,12.1-11.1-4.2-10.6-12.6-10.6h-4.2v-10.3h3.9c6.5,0,11.1-3.3,11.1-9.1s-3.7-9-9.7-9-11.6,5.1-11.9,12.2h-13c.5-13.5,9-22.6,24.9-22.6s23.5,7.1,23.5,18.5-4.9,12.2-11.7,14.4v.2c8.7,2.1,13.9,7.7,13.9,17.2,0,14.2-11.7,21.1-25.8,21.1s-26.8-9.8-27-24.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.8,1165.8h13.4c1.2,6.7,6.8,9.9,13.9,9.9s12.7-5.6,12.7-12.9-5.5-12.6-12.7-12.6-9.2,2-11.2,4.3h-13.1l6.6-37.4h40.4v11.3h-30.9l-2.6,14.8h.2c3-2.6,7.9-4.3,14.2-4.3,12.1,0,23.2,9.1,23.2,23.9s-11.5,24.3-26.5,24.3-26.3-8-27.6-21.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M675.2,935.3c0,7.5-4.8,8.7-11,8.7h-3.3v7.4h-5.6v-24.7h8.9c6.2,0,11,1.2,11,8.6h0ZM669.6,935.3c0-3.4-1.7-3.7-5-3.7h-3.6v7.5h3.6c3.3,0,5-.4,5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678,926.7h17.6v4.9h-12v5h10.3v4.9h-10.3v5h12v4.9h-17.6v-24.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.7,926.7h9.6c5.9,0,11,1.4,11,6.9s-3.3,5.2-6.3,5.5v1.4h3.6c1.9,0,3,1,3,3v7.9h-5.6v-8.7h-9.7v8.7h-5.6v-24.7h0ZM708.3,937.8c3.3,0,5.4,0,5.4-3.1s-2.1-3.1-5.4-3.1h-4v6.2h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.4,926.7h5.6v13c0,4.4.4,7.1,5.5,7.1s5.6-2.7,5.6-7.1v-13h5.6v15.5c0,6.2-3.8,9.5-11.2,9.5s-11.1-3.4-11.1-9.5v-15.5h0ZM739.5,917.9l.9,4-13.7,3-.9-4,13.7-3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M698.3,867.8h-15.5v-9c8.4-.3,15.9-3.4,17.3-12.2h11.9v69h-13.7v-47.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.4,543.8h-15.5v-9c8.4-.3,15.9-3.4,17.3-12.2h11.9v69h-13.7v-47.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1277.3,1214.4c0,7.5-4.8,8.7-11,8.7h-3.3v7.4h-5.6v-24.7h8.9c6.2,0,11,1.2,11,8.6ZM1271.7,1214.4c0-3.4-1.7-3.7-5-3.7h-3.6v7.5h3.6c3.3,0,5-.3,5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.2,1222.5h-10l-2.2,7.9h-5.7l7.1-24.7h11.6l7.1,24.7h-5.7l-2.2-7.9h0ZM1292.8,1217.6l-2.9-10.5h-1.4l-2.9,10.5h7.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.5,1205.8h9.6c5.9,0,11,1.4,11,6.9s-3.3,5.2-6.3,5.5v1.4h3.6c1.9,0,3,1.1,3,3v7.9h-5.6v-8.7h-9.7v8.7h-5.6v-24.7h0ZM1314.1,1216.9c3.3,0,5.4,0,5.4-3.1s-2.1-3.1-5.4-3.1h-4v6.2h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.7,1222.5h-10l-2.2,7.9h-5.7l7.1-24.7h11.6l7.1,24.7h-5.7l-2.2-7.9h0ZM1344.4,1217.6l-2.9-10.5h-1.4l-2.9,10.5h7.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.4,1205.4c6.2,0,11,3.8,11.7,9.2h-5.6c-.6-2.9-2.4-4.3-6.1-4.3s-6.8,2.3-6.8,7.8,2,7.8,6.1,7.8,5.5-1.7,5.5-5h-5.7v-4.2h12.9c1.9,0,3,1,3,3v10.8h-5.6v-8.5l1.1-3.9h-1.4c0,7.7-3.1,12.7-9.9,12.7s-11.4-5.1-11.4-12.7,5.3-12.7,12.4-12.7h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.1,1205.8h5.6v13c0,4.4.4,7.1,5.5,7.1s5.6-2.7,5.6-7.1v-13h5.6v15.5c0,6.2-3.8,9.5-11.2,9.5s-11.1-3.4-11.1-9.5v-15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.6,1222.5h-10l-2.2,7.9h-5.7l7.1-24.7h11.6l7.1,24.7h-5.7l-2.2-7.9h0ZM1423.2,1217.6l-2.9-10.5h-1.4l-2.9,10.5h7.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.3,1205.8l-9.2,16.7v7.9h-5.6v-7.9l-9.1-16.7h6l5.2,10.3v3.2h1.4v-3.2l5.3-10.3h6,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1353.3,1140.2h-15.5v-9c8.4-.3,15.9-3.4,17.3-12.2h11.9v69h-13.7v-47.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M922.4,972.4h7.4c5.9,0,8.7,1,8.7,5.2s-2.8,4-5.1,4.2v1.2c3.2,0,6.6.4,6.6,4.9s-4.4,5.6-9.9,5.6h-7.8v-21.1h0ZM930.4,980.5c1.9,0,3.3,0,3.3-1.9s-1.4-1.9-3.3-1.9h-3.2v3.8h3.2ZM930.8,989.4c2.8,0,4.5,0,4.5-2.3s-1.7-2.4-4.5-2.4h-3.6v4.7h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M952.1,972.1c6.7,0,10.8,4.7,10.8,10.9s-4.1,10.9-10.8,10.9-10.8-4.7-10.8-10.9,4.1-10.9,10.8-10.9ZM952.1,989.7c4,0,6-2.6,6-6.7s-2-6.7-6-6.7-6,2.6-6,6.7,2,6.7,6,6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M965.6,991.4v-18.9h4.8v17.2l10.3-.3v4.2l-12.5.3c-1.7,0-2.6-.9-2.6-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M992.4,976.6v12.8h4.8v4.2h-14.4v-4.2h4.8v-12.8h-4.8v-4.2h14.4v4.2h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1004.2,972.4l5.6,19.9h1.2l5.6-19.9h4.9l-6.1,21.1h-9.9l-6.1-21.1h4.9-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1033.1,976.6v12.8h4.8v4.2h-14.4v-4.2h4.8v-12.8h-4.8v-4.2h14.4v4.2h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1055.3,986.8h-8.6l-1.9,6.8h-4.9l6.1-21.1h9.9l6.1,21.1h-4.9l-1.9-6.8h.1ZM1054.2,982.6l-2.5-9h-1.2l-2.5,9h6.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M935.3,944.8h11.8c1,3.7,4.1,6.8,9.6,6.8s6.8-1.2,8.9-4c2.4-3,4-8.2,4-14.5h-.2c-3.3,3.8-7.6,6.7-14.3,6.7-12.5,0-22-8.4-22-21.5s10-21.5,23.1-21.5,25.5,10.2,25.5,31.1-6.6,32.9-24.8,32.9-20.4-6.9-21.8-16.1h.2ZM969.4,918.4c0-7.1-5.2-12-12.4-12s-12.2,5.2-12.2,11.9,4.4,12,12.1,12,12.5-4.8,12.5-11.9h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "1323.5 1162.8 1169 1162.8 1101.9 1093.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 725.2,
    y1: 881.6,
    x2: 828.3,
    y2: 881.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1021.9,600.9c5.3,0,9.4,3.2,10,7.9h-4.8c-.5-2.5-2.1-3.7-5.2-3.7s-5.8,2-5.8,6.7,1.7,6.7,5.2,6.7,4.7-1.4,4.7-4.3h-4.9v-3.6h11c1.7,0,2.5.9,2.5,2.5v9.2h-4.8v-7.3l.9-3.3h-1.2c0,6.6-2.6,10.9-8.5,10.9s-9.8-4.4-9.8-10.9,4.5-10.9,10.6-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037,601.2h4.8v11.2c0,3.8.3,6.1,4.7,6.1s4.8-2.3,4.8-6.1v-11.2h4.8v13.3c0,5.3-3.3,8.2-9.6,8.2s-9.5-2.9-9.5-8.2v-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.8,605.4v12.7h4.8v4.2h-14.4v-4.2h4.8v-12.7h-4.8v-4.2h14.4v4.2h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090,615.6h-8.6l-1.9,6.8h-4.9l6.1-21.1h9.9l6.1,21.1h-4.9l-1.9-6.8ZM1088.9,611.4l-2.5-9h-1.2l-2.5,9h6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.9,601.2h9.4l6.4,19.9h1.2l-.9-3v-16.9h4.8v21.1h-9.5l-6.4-19.9h-1.2l.9,3v16.9h-4.8v-21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.3,615.6h-8.6l-1.9,6.8h-4.9l6.1-21.1h9.9l6.1,21.1h-4.9l-1.9-6.8ZM1136.1,611.4l-2.5-9h-1.2l-2.5,9h6.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapaDatosPt);
export default __webpack_public_path__ + "static/media/mapa_datos_pt.c7b45b55021cb8eb08e3a97e055b9c0b.svg";
export { ForwardRef as ReactComponent };